// @ts-nocheck
var _learnq = _learnq || []

document.addEventListener("lazybeforeunveil", function (e) {
  var bg = e.target.getAttribute("data-bg")
  if (bg) {
    e.target.style.backgroundImage = "url(" + bg + ")"
    e.target.removeAttribute("data-bg")
    e.target.style.filter = "blur(0px)"
  }
})

// Put your application javascript here
const SingleUpsell = {
  template: /*html*/ `  
  <div class="flex flex-col justify-center items-center bg-[#f2f1f58f] p-4 pb-6 rounded-lg col-span-1 "  v-if="item && !isInCart(item)">
  <div class="w-20 h-20"> 
  <img  :src="current_featured_image" width="1500" height="1500" alt="">
  </div>
  <p class="pt-4 text-center text-darkGreen"
  :href="item.url" 
  >{{item.title}}</p> 
<div v-if="item.variants.length>1" class="block">
              <select @change="updateSelectedVariant" class="upsell-select-updated text-darkGreen pr-[40px] border-0 border-b-1 border-darkGreen focus:outline-none focus:border-darkGreen mb-2 !text-[12px] lg:text-[14px] px-2 " 
              :value="current_variant.id"              >
                <option v-for="variant in item.variants" :key="variant.id" :value="variant.id">
                  {{ variant.title }}
                </option>
              </select>
              <span class="text-darkGreen text-xs font-bold block text-center mb-2" v-if="item.tags.includes('bf-sale')">
               <span v-if="item?.handle?.includes('fasting-shake')">{{moneyDown(current_variant.price*70)}}
              </span>
              <span v-else >{{moneyDown(current_variant.price)}}
              </span>
 
              </span> 
              <span class="text-darkGreen text-xs font-bold block text-center mb-2" v-else>
              {{money(current_variant.price*100)}}
              </span> 
</div> 
<span v-else class="text-darkGreen text-[12px] py-2">
<span>{{item.variants[0].title.replace('Default Title','') }}</span>
 <span class="text-darkGreen text-xs font-bold block text-center mb-2 mt-2" v-if="item.tags.includes('bf-sale')">
             
              <span>
              {{moneyDown(current_variant.price*70)}}
              </span>   
    </span>   
         <span class="text-darkGreen text-xs font-bold block text-center mb-2" v-else>
              {{money(current_variant.price*100)}}
              </span>  
</span>
  <div class="w-100">
  
  <button class="flex flex-col justify-center h-10 px-8 bg-white text-darkGreen rounded-3xl !mx-auto"
   @click="UpsellAddToCart(item)" 
  >
  <div class="flex items-center justify-center cursor-pointer">
  <div class="spinner-loader" v-if="item.loading"> </div>
  <span v-else class="text-xs font-bold">Add</span> 

 

  </div>
  </button>
  </div>
  </div>
 
  `,
  props: ["item", "cart"],

  data() {
    return {
      current_variant: false,
    }
  },
  methods: {
    UpsellAddToCart(item) {
      item.loading = true
      store.addToCartWithProperties({
        id: this.current_variant.id,
        quantity: 1,
        properties: { upsell: true },
        cb: (response) => {
          item.loading = false
        },
      })
    },
    moneyDown(value) {
      if (!value) return '$'+0;
      return "$" + Math.floor(value / 100).toFixed(2)
    },
    money(value) {
      if (!value) return "$0.00"
      return "$" + (value / 100).toFixed(2)
    },
    isInCart(item) {
      return (
        this.cart &&
        this.cart.items &&
        this.cart.items.find((i) => i.product_id === item.id)
      )
    },
    updateSelectedVariant(event) {
      const variantId = event.target.value
      this.current_variant = this.item.variants.find(
        (variant) => variant.id == variantId
      )
    },
  },
  computed: {
    variants() {
      return item.variants
    },
    current_featured_image() {
      let image = this.item.images[0].src || this.item.images[0]
      if (this.current_variant && this.current_variant.featured_image) {
        image = this.current_variant.featured_image.src
      }

      return image
    },
  },
  mounted() {
    if (this.item && this.item.variants && this.item.variants.length > 0) {
      this.current_variant = this.item.variants[0]
    }
  },
}

// Put your application javascript here
const SingleUpsellNew = {
  template: /*html*/ `
  <div class="upsell-card flex h-full w-full items-center gap-3 rounded-[8px] border border-[#1E4036] p-3" v-if="item && !isInCart(item)">
    <div class="upsell-card__media flex h-[112px] w-[104px] shrink-0 items-center justify-center overflow-hidden rounded-[6px]">
      <img :src="current_featured_image" width="300" height="300" alt="" loading="lazy" class="h-full w-full object-contain" />
    </div>

    <div class="flex min-w-0 flex-1 flex-col justify-center gap-[6px]">
      <p class="truncate text-left text-[14px] font-semibold leading-snug text-darkGreen">{{item.title}}</p>

      <div class="flex items-center gap-2">
        <span class="block text-left text-[13px] font-bold text-darkGreen">{{money(current_variant.price*100)}}</span>
        <s v-if="has_compare_price" class="block text-left text-[12px] text-[#1E403699]">{{money(current_variant.compare_at_price*100)}}</s>
      </div>

      <div class="flex items-center gap-2">
        <div v-if="item.variants.length>1" class="relative min-w-0 max-w-[190px] flex-1">
          <select @change="updateSelectedVariant" class="upsell-select-updated h-7 w-full appearance-none rounded-full border border-[#1E4036] bg-transparent pl-3 pr-6 !text-[12px] font-semibold text-darkGreen focus:outline-none" :value="current_variant.id">
            <option v-for="variant in item.variants" :key="variant.id" :value="variant.id" :disabled="variant.available === false">{{ variant.title }}{{ variant.available === false ? ' - Sold Out' : '' }}</option>
          </select>
          <svg class="pointer-events-none absolute right-2 top-1/2 h-3 w-3 -translate-y-1/2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 9l-7 7-7-7" stroke="#1E4036" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span v-else-if="has_variant_label" class="block h-7 max-w-[190px] truncate rounded-full border border-[#1E4036] px-3 py-1 text-[12px] font-semibold text-darkGreen">
          {{item.variants[0].title}}
        </span>

        <button class="bg-lightGreen flex h-7 shrink-0 flex-col justify-center rounded-full px-4 text-center text-white" @click="UpsellAddToCart(item)">
          <div class="mx-auto flex cursor-pointer items-center justify-center text-center">
            <div class="spinner-loader" v-if="item.loading"></div>
            <span v-else class="flex items-center gap-1 text-xs font-bold"><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 0V10" stroke="white" stroke-width="1.5"/>
<path d="M10 5L-1.78814e-07 5" stroke="white" stroke-width="1.5"/>
</svg>
ADD</span>
          </div>
        </button>
      </div>
    </div>
  </div>
  `,
  props: ["item", "cart"],

  data() {
    return {
      current_variant: false,
    }
  },
  methods: {
    UpsellAddToCart(item) {
      item.loading = true
      store.addToCartWithProperties({
        id: this.current_variant.id,
        quantity: 1,
        properties: { upsell: true },
        cb: (response) => {
          item.loading = false
        },
      })
    },
    moneyDown(value) {
      if (!value) return '$'+0;
      return "$" + Math.floor(value / 100).toFixed(2)
    },
    money(value) {
      if (!value) return '$'+0;
      return "$" + (value / 100).toFixed(2)
    },
    isInCart(item) {
      return (
        this.cart &&
        this.cart.items &&
        this.cart.items.find((i) => i.product_id === item.id)
      )
    },
    updateSelectedVariant(event) {
      const variantId = event.target.value
      this.current_variant = this.item.variants.find(
        (variant) => variant.id == variantId
      )
    },
  },
  computed: {
    variants() {
      return item.variants
    },
    has_compare_price() {
      const price = parseFloat(this.current_variant?.price)
      const compare = parseFloat(this.current_variant?.compare_at_price)
      return !isNaN(compare) && !isNaN(price) && compare > price
    },
    // Single variant products with no real variant name (Shopify's "Default Title")
    // should not show the variant pill at all
    has_variant_label() {
      let title = this.item?.variants?.[0]?.title
      if (!title) return false
      title = title.trim().toLowerCase()
      return title !== "default title" && title !== "default"
    },
    current_featured_image() {
      let image = this.item.images[0].src || this.item.images[0]
      if (this.current_variant && this.current_variant.featured_image) {
        image = this.current_variant.featured_image.src
      }

      return image
    },
  },
  mounted() {
    if (this.item && this.item.variants && this.item.variants.length > 0) {
      this.current_variant = this.item.variants[0]
    }
  },
}

// Lean-redesign upsell row (snippets/king-cart-recommendations-lean.liquid).
// Same data + same store.addToCartWithProperties call as SingleUpsellNew above —
// only the markup differs, so the two cart designs stay behaviourally identical.
const LeanUpsellCard = {
  template: /*html*/ `
  <div class="lc-rec-item" v-if="item && !isInCart(item)">
    <div class="lc-rec-thumb-wrap">
      <div class="lc-rec-thumb">
        <img :src="current_featured_image" width="228" height="228" alt="" loading="lazy" />
      </div>
    </div>

    <div class="lc-rec-body">
      <p class="lc-rec-title">{{ item.title }}</p>

      <div class="lc-rec-price-row">
        <span class="lc-rec-price">{{ money(current_variant.price * 100) }}</span>
        <s v-if="has_compare_price" class="lc-rec-compare">{{ money(current_variant.compare_at_price * 100) }}</s>
      </div>

      <div class="lc-variant-select" v-if="item.variants.length > 1">
        <select :value="current_variant.id" @change="updateSelectedVariant" :aria-label="item.title + ' variant'">
          <option v-for="variant in item.variants" :key="variant.id" :value="variant.id" :disabled="variant.available === false">
            {{ variant.title }}{{ variant.available === false ? ' - Sold Out' : '' }}
          </option>
        </select>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M19 9l-7 7-7-7" stroke="#1F3D2B" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="lc-variant-select" v-else-if="has_variant_label">
        <span class="lc-variant-label">{{ item.variants[0].title }}</span>
      </div>
    </div>

    <button class="lc-btn-add" type="button" :disabled="item.loading" @click="UpsellAddToCart(item)">
      <span v-if="item.loading">ADDING...</span>
      <template v-else>
        <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M5 0V10" stroke="white" stroke-width="1.5"/>
          <path d="M10 5L-1.78814e-07 5" stroke="white" stroke-width="1.5"/>
        </svg>
        <span>ADD</span>
      </template>
    </button>
  </div>
  `,
  props: ["item", "cart"],
  data() {
    return {
      current_variant: false,
    }
  },
  methods: {
    UpsellAddToCart(item) {
      item.loading = true
      store.addToCartWithProperties({
        id: this.current_variant.id,
        quantity: 1,
        properties: { upsell: true },
        cb: (response) => {
          item.loading = false
        },
      })
    },
    money(value) {
      if (!value) return "$" + 0
      return "$" + (value / 100).toFixed(2)
    },
    isInCart(item) {
      return (
        this.cart &&
        this.cart.items &&
        this.cart.items.find((i) => i.product_id === item.id)
      )
    },
    updateSelectedVariant(event) {
      const variantId = event.target.value
      this.current_variant = this.item.variants.find(
        (variant) => variant.id == variantId
      )
    },
  },
  computed: {
    has_compare_price() {
      const price = parseFloat(this.current_variant?.price)
      const compare = parseFloat(this.current_variant?.compare_at_price)
      return !isNaN(compare) && !isNaN(price) && compare > price
    },
    // Single-variant products named "Default Title" get no variant pill
    has_variant_label() {
      let title = this.item?.variants?.[0]?.title
      if (!title) return false
      title = title.trim().toLowerCase()
      return title !== "default title" && title !== "default"
    },
    current_featured_image() {
      let image = this.item.images[0].src || this.item.images[0]
      if (this.current_variant && this.current_variant.featured_image) {
        image = this.current_variant.featured_image.src
      }
      return image
    },
  },
  mounted() {
    if (this.item && this.item.variants && this.item.variants.length > 0) {
      this.current_variant = this.item.variants[0]
    }
  },
}

// Scroll snap slider for the "add the essentials" cart upsells.
// Replaces the vue carousel here because its slide width (85%) and the track gap
// don't match the translate math, which made every next slide drift out of view.
const UpsellSlider = {
  template: /*html*/ `
  <div class="w-full" v-if="visible_items.length > 0">
    <div class="upsell-slider flex w-full snap-x snap-mandatory gap-3 overflow-x-auto pb-1" ref="scroller" @scroll="onScroll">
      <div v-for="item in visible_items" :key="item.id" class="upsell-slider__slide shrink-0 snap-start">
        <single-upsell-new :item="item" :cart="cart" class="w-full" />
      </div>
    </div>

    <div class="flex items-center justify-center gap-[6px] pt-3" v-if="visible_items.length > 1">
      <button
        v-for="(item, index) in visible_items"
        :key="'dot-' + item.id"
        type="button"
        :aria-label="'Go to upsell ' + (index + 1)"
        :aria-current="index === active_index"
        @click="goTo(index)"
        class="upsell-slider__dot rounded-full"
        :class="index === active_index ? 'h-[10px] w-[10px] bg-darkGreen' : 'h-2 w-2 bg-[#CCD0CC]'"
      ></button>
    </div>
  </div>
  `,
  props: ["items", "cart"],
  data() {
    return {
      active_index: 0,
    }
  },
  computed: {
    visible_items() {
      if (!this.items || this.items.length == 0) return []
      return this.items.filter((item) => {
        return (
          item &&
          item.variants &&
          item.variants.length > 0 &&
          !this.isInCart(item)
        )
      })
    },
  },
  watch: {
    // Keep the active dot valid when an item gets added to the cart and disappears
    "visible_items.length"(length) {
      if (this.active_index > length - 1) {
        this.active_index = Math.max(length - 1, 0)
      }
    },
  },
  methods: {
    isInCart(item) {
      return (
        this.cart &&
        this.cart.items &&
        this.cart.items.find((i) => i.product_id === item.id)
      )
    },
    slideStep() {
      const scroller = this.$refs.scroller
      if (!scroller) return 0
      const slide = scroller.querySelector(".upsell-slider__slide")
      if (!slide) return scroller.clientWidth
      const gap = parseFloat(getComputedStyle(scroller).columnGap) || 0
      return slide.getBoundingClientRect().width + gap
    },
    onScroll() {
      const scroller = this.$refs.scroller
      const step = this.slideStep()
      if (!scroller || !step) return
      this.active_index = Math.round(scroller.scrollLeft / step)
    },
    goTo(index) {
      const scroller = this.$refs.scroller
      if (!scroller) return
      this.active_index = index
      scroller.scrollTo({ left: index * this.slideStep(), behavior: "smooth" })
    },
  },
  components: {
    "single-upsell-new": SingleUpsellNew,
  },
}

// Put your application javascript here
function getParam(param) {
  return new URLSearchParams(window.location.search).get(param)
}

let clear = getParam("clear")
let discount = getParam("discount")
if (clear == "1") {
  Cookies.set("provider_code", null, { expires: 700 })
  localStorage.setItem("provider_code", null)
  Cookies.set("discount_code", null)
}
if (discount && discount != "") {
  localStorage.setItem("provider_code", null)
  Cookies.set("provider_code", null, { expires: 700 })
  Cookies.set("discount_code", discount)
  //  localStorage.setItem("discount_code", discount);
}

const local_discount_code = Cookies.get("discount_code")
const isLocal = localStorage.getItem("doLocal")
const is_welcome_gift = localStorage.getItem("is_welcome_gift")
const allowedGifts = [
  {
    enabled: false,
    handle: "free-fast-bar-coconut-macadamia-12ct-1",
    description: "Auto Add Free Fasting Bar Coconut Macadamia 12ct",
    variant_id: 45858930032798,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      cart_total: {
        operator: ">=",
        value: 50, // 100.00
      },
      // sku_single_item: {
      //   operator: ">",
      //   value: 50,
      // },
      // skus_in: [
      //   "PR001",
      //   "PR002",
      //   "PR039",
      //   "PR001-RKBUNDLE",
      //   "PR002-RKBUNDLE",
      //   "PR039-RKBUNDLE",
      //   "PR039-3Boxbundle",
      //   "PR004",
      //   "PR039-PNK",
      //   "PR001-2BOX",
      //   "PR002-2BOX",
      //   "PR0039-2BOX",
      //   "PR001-3BOX",
      //   "PR002-3BOX",
      //   "PR0039-3BOX",
      //   "4boxbulk",
      //   "PR039-4Boxbundle",
      //   "3boxbulk",
      //   "HOLIDAY-BUNDLE",
      //   "longevity-bundle",
      //   "if-bundle",
      // ],
      // product_type_single_item: {
      //   operator: "!=",
      //   value: "Upsell",
      // },
    },
  },
  {
    enabled: false,
    handle: "free-prolon-l-biome",
    description: "Auto Add Free L Biome above $150",
    variant_id: 44455316848798,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      cart_total: {
        operator: ">=",
        value: 15000, // 150.00
      },
      never_add_when_item: ["prolon-bundle-offer"],
      // sku_single_item: {
      //   operator: ">",
      //   value: 50,
      // },
      // skus_in: [
      //   "PR001",
      //   "PR002",
      //   "PR039",
      //   "PR001-RKBUNDLE",
      //   "PR002-RKBUNDLE",
      //   "PR039-RKBUNDLE",
      //   "PR039-3Boxbundle",
      //   "PR001-2BOX",
      //   "PR002-2BOX",
      //   "PR0039-2BOX",
      //   "PR001-3BOX",
      //   "PR002-3BOX",
      //   "PR0039-3BOX",
      //   "4boxbulk",
      //   "PR039-4Boxbundle",
      //   "3boxbulk",
      //   "longevity-bundle",
      //   "if-bundle",
      // ],
      // sku_single_item: {
      //   operator: ">",
      //   value: 10,
      // },
      // skus_in: ["HOLIDAY-BUNDLE"],
      // variant_in_cart: [
      //   41640431255710, 41640431124638, 41640431288478, 41640431157406,
      //   41640431321246, 41640431190174,
      // ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false,
    handle: "free-l-spread",
    description: "Auto Add Free l-spread for orders with prolon",
    variant_id: 42962227495070,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      sku_single_item: {
        operator: ">",
        value: 50,
      },

      // skus_in: [
      //   "PR001",
      //   "PR002",
      //   "PR039",
      //   "PR001-RKBUNDLE",
      //   "PR002-RKBUNDLE",
      //   "PR039-RKBUNDLE",
      //   "PR039-3Boxbundle",
      //   "PR001-2BOX",
      //   "PR002-2BOX",
      //   "PR0039-2BOX",
      //   "PR001-3BOX",
      //   "PR002-3BOX",
      //   "PR0039-3BOX",
      //   "4boxbulk",
      //   "PR039-4Boxbundle",
      //   "3boxbulk",
      //   "longevity-bundle",
      //   "if-bundle",
      // ],
      // sku_single_item: {
      //   operator: ">",
      //   value: 10,
      // },
      // skus_in: ["HOLIDAY-BUNDLE"],
      variant_in_cart: [
        42897185931422, 42897185833118, 42897185865886, 42897185898654,
        43716177985694, 43716178018462,
      ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false,
    handle: "free-fasting-shake",
    description: "Auto Add Free fasting shake for orders with prolon",
    variant_id: 43022229536926,
    quantity_to_add: 1, 
    match_quantity: false,
    conditions: {
      isSubscriptionProduct: "yes",
      sku_single_item: {
        operator: ">",
        value: 50,
      },
      skus_in: [
        "PR001",
        "PR002",
        "PR004",
        "PR005",
        "PR039", 

        // "PR001-RKBUNDLE",
        // "PR002-RKBUNDLE",
        // "PR039-RKBUNDLE",
        // "PR039-3Boxbundle",
        // "PR001-2BOX",
        // "PR002-2BOX",
        // "PR0039-2BOX",
        // "PR001-3BOX",
        // "PR002-3BOX",
        // "PR0039-3BOX",
        // "4boxbulk",
        // "PR039-4Boxbundle",
        // "3boxbulk",
        // "longevity-bundle",
        // "if-bundle",
        // "PR001-BUNDLE-3",
        // "PR039Boxbundle-4",
        // "PR039bundle-3"
      ],
      // sku_single_item: {
      //   operator: ">",
      //   value: 10,
      // },
      // skus_in: ["HOLIDAY-BUNDLE"],
      // variant_in_cart: [
      //   // 42897185931422, 42897185833118, 42897185865886, 42897185898654,43716177985694,43716178018462 //affiliates
      //   43658982326430,
      //   43658982293662, 43658982260894, 41640431190174, 41640431321246,
      //   41640431157406, 41640431288478, 41640431124638, 41640431255710,
      // ],
      cart_items: {
        operator: ">=",
        value: 1,
      }, 
    },
  },
  {
    enabled: false,
    handle: "free-l-protein",
    description: "Auto Add Free l-protein for orders with prolon",
    variant_id: 43972864344222,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      sku_single_item: {
        operator: ">",
        value: 50,
      },
      skus_in: [
        "PR001",
        "PR002",
        "PR004",
        "PR039",
        "PR001-RKBUNDLE",
        "PR002-RKBUNDLE",
        "PR039-RKBUNDLE",
        "PR039-3Boxbundle",
        "PR001-2BOX",
        "PR002-2BOX",
        "PR0039-2BOX",
        "PR001-3BOX",
        "PR002-3BOX",
        "PR0039-3BOX",
        "4boxbulk",
        "PR039-4Boxbundle",
        "3boxbulk",
        "longevity-bundle",
        "if-bundle",
        "PR001-BUNDLE-3",
        "PR039Boxbundle-4",
        "PR039bundle-3",
      ],
      // sku_single_item: {
      //   operator: ">",
      //   value: 10,
      // },
      // skus_in: ["HOLIDAY-BUNDLE"],
      // variant_in_cart: [
      //   // 42897185931422, 42897185833118, 42897185865886, 42897185898654,43716177985694,43716178018462 //affiliates
      //   43658982326430,
      //   43658982293662,
      //   43658982260894,
      //   41640431190174,
      //   41640431321246,
      //   41640431157406,
      //   41640431288478,
      //   41640431124638,
      //   41640431255710

      // ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false, //is_welcome_gift == "1" ? true : false,
    handle: "free-welcome-kit-v2",
    description: "Auto Add Free welcome-kit",
    variant_id: 47948612665502,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      sku_single_item: {
        operator: ">",
        value: 50,
      },
      isSubscriptionProduct: "yes",
      skus_in: [
        "PR001",
        "PR002",
        "PR004",
        "PR005",
        "PR039",
        // "PR001-RKBUNDLE",
        // "PR002-RKBUNDLE",
        // "PR039-RKBUNDLE",
        // "PR039-3Boxbundle",
        // "PR001-2BOX",
        // "PR002-2BOX",
        // "PR0039-2BOX",
        // "PR001-3BOX",
        // "PR002-3BOX",
        // "PR0039-3BOX",
        // "4boxbulk",
        // "PR039-4Boxbundle",
        // "3boxbulk",
        // "longevity-bundle",
        // "if-bundle",
        // "PR001-BUNDLE-3",
        // "PR039Boxbundle-4",
        // "PR039bundle-3"
      ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  }, 
    {
    enabled: false, 
    handle: "free-welcome-kit-v2",
    description: "Auto Add Free welcome-kit when prolon-5-day-fmd-26 is in cart",  
    variant_id: 47948612665502,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      handle_in_cart: ["prolon-5-day-fmd-26","prolon-offer"],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: true,
    handle: "free-welcome-kit-lp",
    description:
      "Auto Add Free Welcome Kit (LP) when SKU PR001 / PR039 / PR004 / PR005 / PR006 is in the cart AS A SUBSCRIPTION. One-time purchases of those SKUs do not qualify, and the gift is removed as soon as no qualifying subscription line remains.",
    variant_id: 46834300354718,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      isSubscriptionProduct: "yes",
      // The subscription has to be on one of the SKUs below — an unrelated
      // subscription elsewhere in the cart does not unlock the gift.
      subscription_on_matching_sku: true,
      sku_single_item: {
        operator: ">",
        value: 0,
      },
      skus_in: ["PR001", "PR039", "PR004", "PR005", "PR006"],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false,
    handle: "free-fasting-shake",
    description: "Auto Add Free fasting shake when PR005 SKU is in cart",
    variant_id: 43022229536926,
    quantity_to_add: 1, 
    match_quantity: false,
    conditions: {
      sku_single_item: {
        operator: ">",
        value: 0,
      },
      skus_in: [
        "PR005",
      ],
      cart_items: {
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false, // DISABLED: prolon-offer buy-3 free gift
    handle: "free-l-protein-1",
    description:
      "Auto Add Free L-Protein (Berry) when the combined quantity of prolon-offer and prolon-professional-program-2 (any flavor/variant) is 3 or more; removed when it drops below 3",
    variant_id: 47929945522334,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      // Sums the quantity of every line in the cart that belongs to ANY of the target
      // products below (matched by handle or product_id, across flavors/variants) and
      // only qualifies when that combined quantity reaches the value below.
      product_quantity_total: {
        handles: ["prolon-offer", "prolon-professional-program-2"],
        product_ids: [8602639171742, 8156423520414],
        operator: ">=",
        value: 3,
      },
    },
  },
  {
    enabled: false,
    handle: "free-fasting-bar",
    description:
      "Auto Add Free Fasting Bar when prolon-offer / prolon-professional-program-2 is added as a ONE-TIME variant (not subscription). Removed when no qualifying one-time line remains.",
    // Free gift variant id (product 8777966289054).
    variant_id: 47952751788190,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      // Counts only NON-subscription (one-time) cart lines belonging to the target
      // products (matched by handle or product_id, across flavors/variants).
      // Subscription lines (with a selling_plan_allocation) are ignored.
      product_quantity_total: {
        handles: ["prolon-offer", "prolon-professional-program-2"],
        product_ids: [8602639171742, 8156423520414],
        only_one_time: true,
        operator: ">=",
        value: 1,
      },
    },
  },
  {
    enabled: false,
    handle: "free-fasting-bar",
    description:
      "Auto Add Free Fasting Bar when the combined quantity of SKUs PR038/PR055/PR056/PR057/PR069/PR070 in the cart reaches 3 or more — counted across all those SKUs together (one SKU x3, three different SKUs, 2 of one + 1 of another, etc.). Removed when the combined quantity drops below 3.",
    // Free gift variant id (product 8777966289054).
    variant_id: 47952751788190,
    quantity_to_add: 1,
    match_quantity: false,
    conditions: {
      // Sums the quantity of every cart line whose SKU is in the list below and only
      // qualifies when that combined total reaches value. The gift line is never counted.
      product_quantity_total: {
        skus: ["PR038", "PR055", "PR056", "PR057", "PR069", "PR070"],
        operator: ">=",
        value: 3,
      },
    },
  },
]

if (window.cart_gift) {
  // allowedGifts.push({
  //   enabled: window.cart_gift.enabled,
  //   isDisplay: true,
  //   type: 'choose_gift',
  //   name: 'free_sample',
  //   displayText: `Free Gift`,
  //   targetValue: window.cart_gift.threshold,
  //   icon: 'https://cdn.shopify.com/s/files/1/2569/3918/files/free-shipping-removebg-preview_bd38e921-508a-4fad-bafd-6ce3f7c9ae92.png?v=1677098182',
  //   // handle: 'free-lashies-baby-on-the-go',
  //   description: 'Choose gift options from the collection below',
  //   // variant_id: 40239365980238,
  //   collection_handle: window.cart_gift.collection_handle,
  //   allowed_variants: [41562770767950, 40729757286478],
  //   quantity_to_add: 1,
  //   conditions: {
  //     isSubscriptionProduct: window.cart_gift.isSubscriptionProduct ? 'yes': 'no',
  //     cart_total: {
  //       operator: '>=',
  //       value: window.cart_gift.threshold * 100, // 100.00
  //     },
  //     cart_items: {
  //       operator: '>=',
  //       value: 1,
  //     },
  //   },
  //   successMessage: window.cart_gift.success_message,
  //   remainingMessage: window.cart_gift.remaining_message,
  // });
} 

// Products that should lead the cart upsell slider, in this order.
// Anything else from the prolonlife-cart-upsell collection follows.
const cartUpsellOrder = [
  8280629543070, // fasting-bar
  8752204808350, // reset
]

// The prolonlife-cart-upsell collection also carries the gift-only twins of the
// paid products (free-1-day-reset mirrors reset, free-fasting-bar-1 mirrors
// fasting-bar, ...). Those are added automatically by processAllowedGifts() and
// must never be offered as a paid "Recommended for you" row, otherwise the same
// product shows up twice - once at its real price, once as the "Free ..." copy
// priced like the paid one.
const GIFT_ONLY_HANDLE_PREFIX = "free-"
function isGiftOnlyProduct(product) {
  let handle = (product && product.handle) || ""
  return handle.indexOf(GIFT_ONLY_HANDLE_PREFIX) === 0
}

// Drops the gift-only twins and any product the collection repeats.
function filterRecommendedProducts(products) {
  let seen = {}
  return (products || []).filter((product) => {
    if (!product || isGiftOnlyProduct(product)) {
      return false
    }
    if (seen[product.id]) {
      return false
    }
    seen[product.id] = true
    return true
  })
}

const store = Vue.reactive({
  state: {
    cartState: [],
    loadingCart: true,
    updatingCart: false,
    shopify_cart: null,
    freeGiftsCollection: [],
    recommendedCollection: [],
    allowedGifts: allowedGifts.filter((gift) => gift.enabled),
    upsell_in_cart: false,
    _processingGifts: false,
  },

  getCart() {
    // this.state.loadingCart = true;
    return fetch("/cart.js")
      .then(async (response) => {
        let data = await response.json()
        this.state.loadingCart = false
        this.state.cartState.unshift(data)
        this.state.updatingCart = false
        this.state.cartState.length = 1
        await this.checkCart()
        return data
      })
      .catch((error) => {
        devLog(error)
      })
  },
  // Refresh cart data only (no gift processing) — used after gift updates
  /**
   * Re-read the cart after a mutation.
   *
   * TWO representations have to move together, or the drawer shows half a cart:
   *  - /cart.js          -> state.cartState, everything the line items render from;
   *  - /cart?view=slidecart -> state.shopify_cart, which is the ONLY place
   *    `bundle_components` lives. A native Shopify bundle is one line in
   *    /cart.js with has_components: true and no list of what is inside it.
   *
   * state.shopify_cart used to be refreshed only at the top of
   * processAllowedGifts(), i.e. BEFORE the gift lines for this cycle are added.
   * So a gift that is a bundle — the free 7-bar pack — landed in the cart with
   * its component list still reading the pre-gift cart: the row rendered
   * "Show 0 items" and stayed empty until the shopper reloaded the page, which
   * finally fetched a slidecart view that knew about the line.
   *
   * Fetching both here fixes it for every caller and every gift, not just the
   * promo one. They go out together, so this costs no extra round trip.
   */
  _refreshCartData() {
    return Promise.all([
      fetch("/cart.js").then((response) => response.json()),
      this.getShopifyCart(),
    ])
      .then(([data, shopifyCart]) => {
        this.state.loadingCart = false
        this.state.cartState.unshift(data)
        this.state.updatingCart = false
        this.state.cartState.length = 1
        // getShopifyCart() resolves null on any failure; keeping the previous
        // value is better than blanking every bundle row in the drawer.
        if (shopifyCart) {
          this.state.shopify_cart = shopifyCart
        }
        return data
      })
      .catch((error) => {
        devLog(error)
      })
  },
  async getShopifyCart() {
    return new Promise((resolve) => {
      fetch("/cart?view=slidecart")
        .then(async (response) => {
          try {
            // Check if response is OK
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`)
            }

            // Get response as text first
            const text = await response.text()
            
            // Try to parse the text as JSON
            try {
              const data = JSON.parse(text)
              resolve(data)
            } catch (parseError) {
              devLog("Error parsing cart JSON:", parseError)
              devLog("Response text:", text.substring(0, 500))
              resolve(null)
            }
          } catch (error) {
            devLog("Error fetching cart:", error)
            resolve(null)
          }
        })
        .catch((error) => {
          resolve(null)
          devLog(error)
        })
    })
  },
  setCartLoading() {
    this.state.updatingCart = true
  },
  getRecommendedCollection() {
    fetch("/collections/prolonlife-cart-upsell/products.json")
      .then((response) => response.json())
      .then((data) => {
        if (data && data.products) {
          this.state.recommendedCollection = filterRecommendedProducts(
            data.products
          )
          this.sortRecommendedCollection()
        }
      })
      .catch((error) => {
        devLog(error)
      })
  },
  // cartUpsellOrder wins, everything else keeps the collection order
  sortRecommendedCollection() {
    const rank = (product) => {
      const index = cartUpsellOrder.indexOf(product.id)
      return index == -1 ? cartUpsellOrder.length : index
    }
    this.state.recommendedCollection.sort((a, b) => rank(a) - rank(b))
  },
  getFreeGiftsCollection() {
    axios
      .get("/collections/free-gifts-cart/products.json")
      .then((response) => {
        if (response.data && response.data.products) {
          this.state.freeGiftsCollection = response.data.products
        }
      })
      .catch((error) => {
        devLog(error)
      })
  },
  addToCart(id, quantity, selling_plan, cb) {
    store.setCartLoading()
    let props = { id, quantity }
    if (selling_plan) {
      props.selling_plan = selling_plan
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(props),
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.message && data.status == 422) {
          alert(data.message)
          return
        }

        if (window.doLeadforPodscribe) {
          window.doLeadforPodscribe(id)
        }

        if (window.posthog && window.posthog.capture) {
          window.posthog.capture("direct_add_to_cart", {
            variant_id: id,
            quantity: quantity,
            selling_plan: selling_plan,
          })
        }
        await store.getCart()
        if (cb) cb(data)
        else toggleCart.showCart()
      })
      .catch((error) => {
        devLog(error)
      })
  },

  addToCartWithProperties({ id, quantity, selling_plan, cb, properties }) {
    store.setCartLoading()

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [{ id, quantity, selling_plan, properties }],
      }),
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (window.doLeadforPodscribe) {
          window.doLeadforPodscribe(id)
        }

        if (window.posthog && window.posthog.capture) {
          let isUpsell = properties && properties.upsell
          window.posthog.capture("direct_add_to_cart", {
            variant_id: id,
            quantity: quantity,
            selling_plan: selling_plan,
            properties: properties,
            isUpsell: isUpsell,
          })
        }
        await store.getCart()
        if (cb) cb(data)
        else toggleCart.showCart()
      })
      .catch((error) => {
        devLog(error)
      })
  },

  async bulkAddToCart(items, cb) {
    store.setCartLoading()
    await fetch("/cart/clear.js", { method: "POST" })
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((response) => response.json())
      .then(async (data) => {
        await store.getCart()
        if (cb) cb(data)
      })
      .catch((error) => {
        devLog(error)
      })
  },

  async bulkAddToCartClear(items, cb) {
    store.setCartLoading()

    // Clearing the cart
    try {
      const clearResponse = await fetch("/cart/clear.js", { method: "POST" })
      if (!clearResponse.ok) {
        throw new Error("Error clearing cart")
      }

      // Adding items to cart
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      })

      if (!addResponse.ok) {
        throw new Error("Error adding items to cart")
      }

      const data = await addResponse.json()
      await store.getCart()
      if (cb) cb(data)
    } catch (error) {
      devLog(error)

      // Error handling logic
      if (error instanceof Error) {
        // Handle Fetch API errors
        alert(error.message)
      } else {
        // Handle other types of errors (e.g., network issues)
        alert("An unexpected error occurred")
      }

      if (cb) cb(error)
    }
  },

  async bulktUpdateCart(items, cb, attributesData) {
    let new_items = {}
    for (let key of Object.keys(items)) {
      if (items[key] >= 0 && key != undefined) new_items[key] = items[key]
    }
    items = new_items

    let isItems = Object.keys(items).length > 0
    if (!isItems && !attributesData) {
      return
    }
    store.setCartLoading()

    let json_key = Object.keys(items).join("_")
    let errorCount = window[`error_${json_key}`] || 0
    let errorLimit = 3
    if (errorCount >= errorLimit) {
      devLog(`Error limit reached for ${json_key}`)
      return
    }
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: items,
        attributes: {
          _free_gift_above_subtotal: JSON.stringify(
            [
              {
                free_gift_variant_id: "45779086442654",
                above_subtotal: 199,
              },
            ].concat(promoGiftDiscountEntries())
          ),
        },
      }),
    })
      .then(async (response) => {
        try {
          // Check if response is OK
          if (!response.ok) {
            if (response.status === 429) {
              devLog("Too many requests - rate limited")
              window[`error_${json_key}`] = ++errorCount
              return { status: "too_many_requests" }
            }
            throw new Error(`HTTP error! status: ${response.status}`)
          }

          const contentType = response.headers.get("content-type")
          if (!contentType || !contentType.includes("application/json")) {
            throw new Error("Response is not JSON")
          }

          return await response.json()
        } catch (error) {
          devLog("Error parsing cart update response:", error)
          window[`error_${json_key}`] = ++errorCount
          return { status: "error", error: error.message }
        }
      })
      .then(async (data) => {
        if (data.status == "too_many_requests") {
          window[`error_${json_key}`] = ++errorCount
        } else if (data.status == "error") {
          devLog("Cart update error:", data.error)
        } else if (!store.state._processingGifts) {
          // Only auto-refresh cart if not inside gift processing
          // (gift processing does its own _refreshCartData at the end)
          store.getCart()
        }
        if (cb) cb(data)
      })
      .catch((error) => {
        window[`error_${json_key}`] = errorCount++

        devLog(error)
      })
  },

  async checkRecommendedUpsells(cart) {
    if (cart) {
      totalRecommendationProductsinCart = 0
      cart.items.forEach((item) => {
        if (
          item &&
          this.state.recommendedCollection &&
          this.state.recommendedCollection.length > 0
        ) {
          this.state.recommendedCollection.forEach((product) => {
            if (item.product_id == product.id) {
              totalRecommendationProductsinCart++
            }
          })
        }
      })

      if (
        totalRecommendationProductsinCart > 0 &&
        totalRecommendationProductsinCart == cart.items.length
      ) {
        // this.clearCart()
      } 
    }
  },
  async processAllowedGifts(cart) {
    let _shopifyCart = await this.getShopifyCart()
    this.state.shopify_cart = _shopifyCart
 
    // console.log(_shopifyCart);

    if (cart && cart.items && cart.items.length > 0) {
      let giftsToUpdate = {}
      let cartAttributes = cart.attributes
      let giftCartProducts = []

      this.state.allowedGifts.forEach((gift) => {
        let giftInCart = false
        let giftVariantInCart = false
        let giftQuantityInCart = 0
        let giftConditionsMet = true
        let skus_in = gift.conditions.skus_in
        let InvalidProductType = false
        let ConditionalProductQuantity = 0
        let isSubscriptionProduct = false
        let isSubscriptionOnMatchingSku = false

        if (gift.conditions.product_type_single_item) {
          if (gift.conditions.product_type_single_item.operator == "!=") {
            InvalidProductType = gift.conditions.product_type_single_item.value
          }
        }

        cart.items.forEach((item) => {
          let itemCounted = false
          if (item.variant_id == gift.variant_id) {
            giftVariantInCart = true
            giftInCart = true
            giftQuantityInCart = item.quantity
          }
          if (skus_in && skus_in.length > 0) {
            skus_in.forEach((sku) => {
              if (item.sku == sku) {
                ConditionalProductQuantity += item.quantity
                itemCounted = true
              }
              // Subscription check scoped to the SKU itself (see
              // subscription_on_matching_sku below), so a subscription on some
              // other product in the cart can't unlock the gift.
              if (
                item.sku &&
                String(item.sku).toUpperCase() == String(sku).toUpperCase() &&
                item.selling_plan_allocation &&
                item.selling_plan_allocation.price
              ) {
                isSubscriptionOnMatchingSku = true
              }
            })
          }
          if (
            item.selling_plan_allocation &&
            item.selling_plan_allocation.price
          ) {
            isSubscriptionProduct = true
          }
          if (
            !itemCounted &&
            gift.conditions.variant_in_cart &&
            gift.conditions.variant_in_cart.length > 0
          ) {
            gift.conditions.variant_in_cart.forEach((variant) => {
              if (item.variant_id == variant) {
                ConditionalProductQuantity += item.quantity
              }
            })
          }
        })

        if (gift.conditions.cart_total) {
          if (gift.conditions.cart_total.operator == ">=") {
            if (cart.total_price < gift.conditions.cart_total.value) {
              giftConditionsMet = false
            }
          }
        }

        if (gift.conditions.cart_items) {
          if (gift.conditions.cart_items.operator == ">=") {
            if (cart.item_count < gift.conditions.cart_items.value) {
              giftConditionsMet = false
            }
          }
        }

        if (gift.conditions.skus_in && gift.conditions.skus_in.length > 0) {
          let skuInCart = false
          gift.conditions.skus_in.forEach((sku) => {
            let cartItems = cart.items

            cartItems.forEach((item) => {
              let productType = item.product_type
              if (
                InvalidProductType &&
                productType.toUpperCase() == InvalidProductType.toUpperCase()
              ) {
              } else if (
                item.sku &&
                item.sku.toUpperCase() == sku.toUpperCase()
              ) {
                let price = item.price / 100
                let pricetoCompare = gift.conditions.sku_single_item
                if (pricetoCompare.operator == ">") {
                  if (price > pricetoCompare.value) {
                    skuInCart = true
                  }
                }

                // skuInCart = true;
              }
            })
          })

          if (!skuInCart) {
            giftConditionsMet = false
          }
        } else if (
          gift.conditions.variant_in_cart &&
          gift.conditions.variant_in_cart.length > 0
        ) {
          giftConditionsMet = false
          gift.conditions.variant_in_cart.forEach((variant) => {
            cart.items.forEach((item) => {
              if (item.variant_id == variant) {
                giftConditionsMet = true
              }
            })
          })

          if (!giftConditionsMet) {
            giftConditionsMet = false
          }
        }

        if (
          gift.conditions.handle_in_cart &&
          gift.conditions.handle_in_cart.length > 0
        ) {
          let handleFound = false
          cart.items.forEach((item) => {
            if (gift.conditions.handle_in_cart.includes(item.handle)) {
              handleFound = true
            }
          })
          if (!handleFound) {
            giftConditionsMet = false
          }
        }

        // Combined-quantity condition: sum the quantity of every cart line that belongs
        // to the target product (matched by handle or product_id), across all flavors/variants.
        // The gift line itself is never counted so it can't keep itself alive.
        if (gift.conditions.product_quantity_total) {
          let cond = gift.conditions.product_quantity_total
          let targetHandles = cond.handles || (cond.handle ? [cond.handle] : [])
          let targetProductIds =
            cond.product_ids || (cond.product_id ? [cond.product_id] : [])
          let targetSkus = (cond.skus || (cond.sku ? [cond.sku] : [])).map(
            (s) => String(s).toUpperCase()
          )
          let matchedQuantity = 0
          cart.items.forEach((item) => {
            if (item.variant_id == gift.variant_id) return
            // When only_one_time is set, ignore subscription lines (those carry a
            // selling_plan_allocation) so the gift only fires for one-time purchases.
            if (
              cond.only_one_time &&
              item.selling_plan_allocation &&
              item.selling_plan_allocation.price
            ) {
              return
            }
            // Bundle support: native Shopify bundles appear as ONE line in cart.js
            // whose own SKU is the bundle's SKU (not the inner products). The inner
            // components — with their real SKUs — live in the slidecart cart data
            // (bundle_components). When this line is a bundle, count its matching
            // components instead of the parent line.
            if (targetSkus.length > 0 && _shopifyCart) {
              let shopifyLine = _shopifyCart.find(
                (s) => s.variant_id == item.variant_id
              )
              let components = shopifyLine && shopifyLine.bundle_components
              if (components && components.length > 0) {
                components.forEach((c) => {
                  if (
                    c.sku &&
                    targetSkus.includes(String(c.sku).toUpperCase())
                  ) {
                    matchedQuantity += Number(c.quantity) || 0
                  }
                })
                return // parent bundle line accounted for via its components
              }
            }
            let matchesHandle = targetHandles.includes(item.handle)
            let matchesProduct = targetProductIds.includes(item.product_id)
            let matchesSku =
              item.sku && targetSkus.includes(item.sku.toUpperCase())
            if (matchesHandle || matchesProduct || matchesSku) {
              matchedQuantity += item.quantity
            }
          })
          let quantityConditionMet
          switch (cond.operator) {
            case ">=":
              quantityConditionMet = matchedQuantity >= cond.value
              break
            case ">":
              quantityConditionMet = matchedQuantity > cond.value
              break
            case "==":
              quantityConditionMet = matchedQuantity == cond.value
              break
            case "<=":
              quantityConditionMet = matchedQuantity <= cond.value
              break
            case "<":
              quantityConditionMet = matchedQuantity < cond.value
              break
            default:
              quantityConditionMet = false
          }
          if (!quantityConditionMet) {
            giftConditionsMet = false
          }
        }

        if (
          gift.conditions.isSubscriptionProduct == "yes" &&
          isSubscriptionProduct == false
        ) {
          giftConditionsMet = false
        }

        // Stricter variant of the check above: the subscription must be on one of
        // the gift's own skus_in lines, not just anywhere in the cart.
        if (
          gift.conditions.subscription_on_matching_sku &&
          isSubscriptionOnMatchingSku == false
        ) {
          giftConditionsMet = false
        }

        if (gift.match_quantity && ConditionalProductQuantity > 0) {
          gift.quantity_to_add = ConditionalProductQuantity
        }

        if (gift.conditions.never_add_when_item) {
          let neverAddWhenItem = gift.conditions.never_add_when_item
          let neverAddWhenItemInCart = false
          cart.items.forEach((item) => {
            if (neverAddWhenItem.includes(item.handle)) {
              neverAddWhenItemInCart = true
            }
          })
          if (neverAddWhenItemInCart) {
            giftConditionsMet = false
          }
        }
        // // hardcode checked for no free shake A/B Test
        // if (window.no_free_shake == true && gift.variant_id == 43022229602462) {
        //   giftConditionsMet = false;
        // }
        if (giftConditionsMet) {
          let productId = gift.conditions?.product_id?.[0]
          let productInCart = cart.items.find((e) => e.product_id == productId)

          let isAlreadyIngiftCartProducts = giftCartProducts.find(
            (e) => e.if_product_id == productId
          )

          if (productId && !isAlreadyIngiftCartProducts) {
            giftCartProducts.push({
              if_product_variant_id: productInCart.variant_id,
              if_product_id: productInCart.product_id,
              free_gift_variant_id: gift.variant_id,
              quantity: gift.quantity_to_add,
            })
          }
        }
        if (gift.variant_id) {
          if (giftConditionsMet && !giftInCart && !giftVariantInCart) {
            giftsToUpdate[gift.variant_id] = gift.quantity_to_add
          } else if (
            giftConditionsMet &&
            giftVariantInCart &&
            giftQuantityInCart != gift.quantity_to_add
          ) {
            giftsToUpdate[gift.variant_id] = gift.quantity_to_add
          } else if (!giftConditionsMet && giftInCart) {
            giftsToUpdate[gift.variant_id] = 0
          } else if (!giftConditionsMet && giftVariantInCart) {
            giftsToUpdate[gift.variant_id] = 0
          }
        }
      })

      if (giftsToUpdate && Object.keys(giftsToUpdate).length > 0) {
        let itemsToUpdate = {} 

        Object.keys(giftsToUpdate).forEach((key) => {
          let isRemoved = Cookies.get(`rrremoved_${key}`)
          if (isRemoved == "true") {
          } else {
            itemsToUpdate[key] = giftsToUpdate[key]
          }
        })

        let attributesData
        if (giftCartProducts.length > 0) {
          attributesData = {
            _free_gift_with_product: JSON.stringify(giftCartProducts),
          }
        }

        let itemsLength = Object.keys(itemsToUpdate).length

        if (
          itemsLength > 0 &&
          giftsToUpdate &&
          Object.keys(giftsToUpdate).length > 0
        ) {
          await this.bulktUpdateCart(itemsToUpdate, null, attributesData)
        } else {
          let attributesData = cartAttributes
          let _free_gift_with_product = cartAttributes?._free_gift_with_product
          if (
            _free_gift_with_product &&
            _free_gift_with_product.length > 0 &&
            giftCartProducts.length == 0
          ) {
            attributesData = {
              _free_gift_with_product: "",
            }
            await this.bulktUpdateCart({}, attributesData)
          }
        }
      }
    }

    if (!cart || !cart.items || cart.items.length == 0) {
      return
    }

    // let cartTotal = cart.total_price / 100;
    let hasResetWeekProduct = cart?.items?.find((item) => {
      return item.properties._reset_week
    })
    let has_reset_week_upsells = cart?.items?.filter((item) => {
      return item.properties._reset_week_upsell
    })

    if (!hasResetWeekProduct && has_reset_week_upsells.length > 0) {
      // Remove all reset week upsells if no reset week product is in the cart
      let itemsToUpdate = {}
      has_reset_week_upsells.forEach((item) => {
        itemsToUpdate[item.id] = 0
      })
      this.bulktUpdateCart(itemsToUpdate, null, {
        _reset_week_upsell: "",
      })
    }

    // L-Protien

    // let cartTotal = cart.total_price / 100;
    let hasLProteinProduct = cart?.items?.find((item) => {
      return item.properties._l_protein
    })
    let has_l_protein_upsells = cart?.items?.filter((item) => {
      return item.properties._l_protein_upsell
    })

    if (!hasLProteinProduct && has_l_protein_upsells.length > 0) {
      // Remove all reset week upsells if no reset week product is in the cart
      let itemsToUpdate = {}
      has_l_protein_upsells.forEach((item) => {
        itemsToUpdate[item.id] = 0
      })
      this.bulktUpdateCart(itemsToUpdate, null, {
        _l_protein_upsell: "",
      })
    }

    // Free Welcome Kit — auto-sync based on _free_welcome_kit property on parent items.
    // Add the kit to cart when a parent item carries the property; remove it when the parent leaves.
    // Toggle: set to false to disable the Free Welcome Kit gift (won't be added; removed if already present).
    // DISABLED: superseded by the free-welcome-kit-lp gift rule in allowedGifts
    // (variant 46834300354718, subscription on PR001/PR039/PR004/PR005/PR006 only).
    // Kept false so any old kit still sitting in a cart gets removed.
    const FREE_WELCOME_KIT_ENABLED = false
    const FREE_WELCOME_KIT_VARIANT_ID = 47948612665502
    // Products that qualify for the Free Welcome Kit on subscription only (first month only,
    // since the kit is added as a one-time line item, not part of the selling plan).
    const FREE_WELCOME_KIT_SUBSCRIPTION_PRODUCT_IDS = [8156423520414] // prolon-professional-program-2
    let hasWelcomeKitParent = cart?.items?.some(
      (item) =>
        (item.properties && item.properties._free_welcome_kit) ||
        (item.selling_plan_allocation &&
          FREE_WELCOME_KIT_SUBSCRIPTION_PRODUCT_IDS.includes(item.product_id))
    )
    let welcomeKitInCart = cart?.items?.find(
      (item) => item.variant_id == FREE_WELCOME_KIT_VARIANT_ID
    )

    if (!FREE_WELCOME_KIT_ENABLED) {
      // Gift disabled: never add it, and clean up any kit that's still in the cart.
      if (welcomeKitInCart) {
        await this.bulktUpdateCart({ [welcomeKitInCart.id]: 0 })
      }
    } else if (hasWelcomeKitParent && !welcomeKitInCart) {
      // Respect the user removing it (rrremoved_ cookie convention used by gift logic)
      let removedCookie = typeof Cookies !== "undefined"
        ? Cookies.get(`rrremoved_${FREE_WELCOME_KIT_VARIANT_ID}`)
        : null
      if (removedCookie !== "true") {
        try {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  id: FREE_WELCOME_KIT_VARIANT_ID,
                  quantity: 1,
                  properties: { _free_welcome_kit_gift: true },
                },
              ],
            }),
          })
        } catch (e) {
          devLog("Error adding free welcome kit:", e)
        }
      }
    } else if (!hasWelcomeKitParent && welcomeKitInCart) {
      // Parent gone — remove the welcome kit
      await this.bulktUpdateCart({ [welcomeKitInCart.id]: 0 })
    }
  },
  /**
   * PROMO GIFTS — auto-add / auto-remove.
   *
   * Keeps the cart's gift lines equal to promoGiftEarnedLines(): every gift
   * variant (qty 1) once the cart holds `goalQty` FMD boxes, or — in spend
   * mode — one line of every gift per spend tier reached. A line whose tier the
   * cart drops back under is pulled out again, leaving the lower tiers' lines.
   * Runs on every cart change via ProcessCartGifts(), which is already guarded
   * against re-entrancy.
   *
   * Safety rules:
   *  - only lines carrying the _promo_gift property are ever added or removed,
   *    so a shopper who bought bars / a Reset kit themselves keeps them;
   *  - the count comes from promoGiftQualifyingQty(), which ignores gift lines,
   *    so a gift can never help unlock itself;
   *  - a shopper who removes a gift themselves keeps it removed for the day
   *    (rrremoved_ cookie, same convention as the other gift rules);
   *  - with the promo switched off, any gift line left in an old cart is
   *    cleaned up — and so is a gift that is no longer part of the promo.
   */
  async processPromoGifts(cart) {
    const config = resolvePromoGiftConfig()
    if (!cart || !Array.isArray(cart.items)) {
      return
    }

    let promoLines = cart.items.filter(isPromoGiftLine)

    if (!config.enabled) {
      if (promoLines.length > 0) {
        devLog("Promo gifts disabled — removing leftover gift lines")
        let cleanup = {}
        promoLines.forEach((line) => {
          cleanup[line.key] = 0
        })
        await this.bulktUpdateCart(cleanup)
      }
      return
    }

    // One entry per gift line the cart has earned — per tier reached, in spend
    // mode. See promoGiftEarnedLines().
    let earnedLines = promoGiftEarnedLines(cart)
    let updates = {}
    let itemsToAdd = []

    // A gift line the cart has not earned goes out: its tier is no longer
    // reached, or the config changed under an open cart and the promo no
    // longer owns that gift or tier. An earned one stays at quantity 1, one
    // line per tier, whatever the shopper does with the quantity picker.
    promoLines.forEach((line) => {
      if (!earnedLines.some((earned) => isPromoGiftLineFor(line, earned))) {
        updates[line.key] = 0
      } else if (line.quantity !== 1) {
        updates[line.key] = 1
      }
    })

    earnedLines.forEach((earned) => {
      if (promoLines.some((line) => isPromoGiftLineFor(line, earned))) {
        return
      }
      if (promoGiftAddFailures[earned.variantId]) {
        // Already rejected by Shopify this page-load — don't hammer the API.
        return
      }
      let removedByShopper =
        typeof Cookies !== "undefined"
          ? Cookies.get(`rrremoved_${earned.variantId}`)
          : null
      if (removedByShopper !== "true") {
        itemsToAdd.push({
          id: Number(earned.variantId),
          quantity: 1,
          properties: {
            [PROMO_GIFT_PROPERTY]: earned.tag,
          },
        })
      }
    })

    if (Object.keys(updates).length > 0) {
      devLog("Promo gifts — updating lines", updates)
      await this.bulktUpdateCart(updates)
    }

    // Added one request per gift on purpose. /cart/add.js is atomic: batch them
    // all and a single unavailable variant (sold out, or a product that needs a
    // selling plan) makes the whole call 422 and NOTHING is added. One call per
    // gift keeps them independent.
    for (let item of itemsToAdd) {
      await this.addPromoGift(item)
    }
  },

  async addPromoGift(item) {
    try {
      let response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: [item] }),
      })

      if (response.ok) {
        devLog("Promo gift added", item.id)
        return true
      }

      // Shopify explains exactly why in the body (sold out, selling plan
      // required, variant not found...). Remember the failure so we stop
      // retrying it on every single cart change, and make it visible.
      let detail = ""
      try {
        let body = await response.json()
        detail = body.description || body.message || JSON.stringify(body)
      } catch (e) {
        detail = "HTTP " + response.status
      }
      promoGiftAddFailures[item.id] = detail
      console.warn(
        `[promo gift] variant ${item.id} could not be added: ${detail}`
      )
    } catch (error) {
      promoGiftAddFailures[item.id] = String(error)
      devLog("Error adding promo gift:", error)
    }
    return false
  },
  async ProcessCartGifts() {
    // Prevent re-entrant calls (e.g. when bulktUpdateCart triggers getCart again)
    if (this.state._processingGifts) {
      return
    }
    this.state._processingGifts = true

    try {
      // Add or Remove Cart Gifts based on allowedGifts
      if (this.state.cartState && this.state.cartState.length > 0) {
        let cart = this.state.cartState[0]

        // Auto-remove expedited shipping if it's the only item left in the cart
        const expeditedShippingVariantId = 43035645640862
        if (cart && cart.items && cart.items.length > 0) {
          let nonExpedited = cart.items.filter((ci) => ci.variant_id !== expeditedShippingVariantId)
          let expeditedItem = cart.items.find((ci) => ci.variant_id === expeditedShippingVariantId)
          if (nonExpedited.length === 0 && expeditedItem) {
            devLog("Auto-removing expedited shipping — no other products in cart")
            await this.bulktUpdateCart({ [expeditedItem.key]: 0 })
            // Refresh cart data after gift update so UI reflects changes immediately
            await this._refreshCartData()
            return
          }
        }

        await this.checkRecommendedUpsells(cart)
        await this.processAllowedGifts(cart)
        await this.processPromoGifts(cart)
        // Refresh cart data after gift processing so UI reflects any gift additions/removals immediately
        await this._refreshCartData()
      }
    } finally {
      this.state._processingGifts = false
    }
    // The promo goal moved while this pass ran on the old one (the A/B tool
    // calling PromoGift.setGoal() during the first cart load) — go again.
    if (this.state._promoGiftRecheck) {
      this.state._promoGiftRecheck = false
      await this.ProcessCartGifts()
    }
  },
  checkCart() {
    return this.ProcessCartGifts()
  },
  // Re-reads the promo config and re-syncs the gift lines to it. Called when
  // window.PromoGift's goal changes; see the promo-gift:goal listener.
  recheckPromoGifts() {
    if (this.state._processingGifts) {
      this.state._promoGiftRecheck = true
      return
    }
    return this.ProcessCartGifts()
  },
  clearCart() {
    devLog(`Clearing Cart`)
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        return response.json()
      })
      .then((data) => {
        this.getCart()
      })
      .catch((error) => {
        devLog(error)
      })
  },
  allowedVariants(gift) {
    let collection_handle = gift.collection_handle
    let allowed_variants = []
    if (collection_handle == "free-gifts-cart") {
      let products = this.state.freeGiftsCollection
      if (products && products.length > 0) {
        products.forEach((product) => {
          if (product.variants && product.variants.length > 0) {
            product.variants.forEach((variant) => {
              allowed_variants.push(variant.id)
            })
          }
        })
      }
    }

    return allowed_variants || []
  },
})

const slideCartState = Vue.reactive({
  hidden: true,
})
// The element that had focus when the drawer opened; focus goes back to it on close.
let slideCartOpener = null
// Focus trap for the open drawer: the same keydown and focusin handlers assets/focus.js
// installs for the header drawer, except first/last are looked up on every key press,
// because the rows, upsells and footer here render from cart data after the drawer opens.
const slideCartRoot = () =>
  document.querySelector('#cart-with-header [role="dialog"][aria-modal="true"]')
const slideCartFocusable = (root) =>
  Array.from(
    root.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((el) => el.offsetWidth || el.offsetHeight || el.getClientRects().length)
const slideCartTrap = {
  keydown(event) {
    if (event.key !== "Tab") return
    const root = slideCartRoot()
    if (!root) return
    const focusable = slideCartFocusable(root)
    if (!focusable.length) return
    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    const active = document.activeElement
    if (!event.shiftKey && active === last) {
      event.preventDefault()
      first.focus()
    } else if (event.shiftKey && (active === first || active === root)) {
      event.preventDefault()
      last.focus()
    }
  },
  focusin(event) {
    const root = slideCartRoot()
    if (root && event.target instanceof Node && !root.contains(event.target)) {
      event.stopPropagation()
      ;(slideCartFocusable(root)[0] || root).focus()
    }
  },
}

const toggleCart = {
  openCart() {
    slideCartState.hidden = !slideCartState.hidden
    menuState.hidden = true

    if (slideCartState.hidden) {
      document.body.classList.remove("slide-cart-open")
    } else {
      document.body.classList.add("slide-cart-open")
    }
  },
  showCart() {
    //SuperCart.ShowCartfn();
    slideCartState.hidden = false
    menuState.hidden = true
    document.body.classList.add("slide-cart-open")
    store.getCart()
    if (window.posthog) {
      window.posthog.capture("view_slide_cart")
    }
  },
}

const menuState = Vue.reactive({
  hidden: true,
})

const toggleMenu = {
  openMenu() {
    menuState.hidden = !menuState.hidden
    slideCartState.hidden = true
  },
}

const toggleClose = {
  closeAll() {
    slideCartState.hidden = true
    menuState.hidden = true
    document.body.classList.remove("slide-cart-open")
  },
}

const freeShippingSettings = {
  freeShippingThreshold: 19900,
  freeShippingMessage: "FREE SHIPPING AT _value_",
  remainingMessage: "YOU'RE _value_ AWAY",
  successMessage: "🎉 You’ve earned free shipping!",
}

// Every product sold on /products/prolon-professionals (the hcp-lp template):
// the page product itself, the popup buy-card product, the five patient cards,
// the starter pack, and the two card upsells. A subscription on any of these
// earns the 20% HCP rate — everything else stays on the flat 5% (each +5% while
// the "HCP extra 5% discount" theme setting is on). See hcpLineRate. Kept in sync with the same list in sections/checkout-section.liquid.
const HCP_SUBSCRIPTION_HANDLES = [
  "prolon-professionals",
  "prolon-professional",
  "reset-patient-v2",
  "fasting-bar-patient-v2",
  "fasting-shake-patient-v2",
  "l-protein-patient-v2",
  "prolon-l-pill-patient-v2",
  "longevity-starter-pack",
  "3x-reset-bundle-patient",
  "fasting-shake-4",
]
// Same products by id — the cart payload always carries product_id, handle is
// the fallback.
const HCP_SUBSCRIPTION_PRODUCT_IDS = [
  7130519109790, 8156423520414, 8156994404510, 8156996534430, 8156998926494,
  8157001449630, 8157003645086, 8831007719582, 7991429922974, 7393863106718,
]
// The Prolon 5-Day Fasting Mimicking Program kit (page product + popup buy-card
// product) always stays on 5% one-time / 20% subscription — the extra 5% never
// applies to it. Kept in sync with isFiveDayLine in
// sections/checkout-section.liquid.
const HCP_FIVE_DAY_HANDLES = ["prolon-professionals", "prolon-professional"]
const HCP_FIVE_DAY_PRODUCT_IDS = [7130519109790, 8156423520414]

//   window.API_URL = "http://localhost:1337/";
window.API_URL = "https://prolon-pro.herokuapp.com/"
window.local_host = localStorage.getItem("doLocal")
if (local_host == 1) {
  window.API_URL = "http://localhost:1337/"
}

/**
 * PROMO GIFT PROGRESS BAR — "Do the 5-Day together": buy N FMD boxes and the gift
 * set is added free. Takes the place of the free-shipping bar in the slide cart
 * while the promo is on.
 *
 * Gifts, copy and the on/off switch all live in
 * snippets/king-promo-gift-config.liquid (window.PROMO_GIFT_BAR). This only
 * resolves that config and lets ?promo_gift_bar=1 force it on for QA
 * (?promo_gift_bar=0 forces the old free-shipping bar back).
 */
let _promoGiftConfigCache = null
function resolvePromoGiftConfig() {
  if (_promoGiftConfigCache) {
    return _promoGiftConfigCache
  }
  const config = window.PROMO_GIFT_BAR || {}

  // Each tile normalised to a list of variant ids, so one tile can carry one
  // gift or — as this promo does — two of the same thing.
  const gifts = (Array.isArray(config.gifts) ? config.gifts : []).map((gift) => {
    let ids = Array.isArray(gift.variantIds)
      ? gift.variantIds
      : gift.variantId
      ? [gift.variantId]
      : []
    return Object.assign({}, gift, { variantIds: ids.map(String) })
  })

  // SKU -> how many FMD boxes one unit of it is worth. The plain SKUs are one
  // box each; the bundles in skuBoxCounts are worth what they say, so a 2-box
  // bundle unlocks the promo on its own. Upper-cased on both sides so a cart
  // line can never miss on letter case.
  const boxCounts = {}
  ;(Array.isArray(config.qualifyingSkus) ? config.qualifyingSkus : []).forEach(
    (sku) => {
      boxCounts[String(sku).trim().toUpperCase()] = 1
    }
  )
  Object.keys(config.skuBoxCounts || {}).forEach((sku) => {
    boxCounts[String(sku).trim().toUpperCase()] =
      Number(config.skuBoxCounts[sku]) || 1
  })

  // Product-id gate. When this list is non-empty ONLY lines from these products
  // can count towards the goal — the SKU list stops qualifying on its own and is
  // left doing nothing but carrying box counts. That is what makes the promo
  // product-specific: the FMD SKUs (PR001/PR004/PR005/PR039) sit on several
  // products in this store, so a SKU alone cannot tell "Prolon Professional
  // Program" apart from the retail boxes.
  const productIds = (
    Array.isArray(config.qualifyingProductIds) ? config.qualifyingProductIds : []
  )
    .map((id) => String(id).trim())
    .filter(Boolean)

  let enabled = config.enabled === true

  // ?promo_gift_bar=1 forces the promo on for QA. It is remembered for the rest
  // of the browsing session, because add-to-cart and PDP navigation drop query
  // params — without this the promo would silently switch off mid-test and no
  // gift would be added. ?promo_gift_bar=0 clears it again.
  let override = getParam("promo_gift_bar")
  try {
    if (override === "1" || override === "true") {
      sessionStorage.setItem("promo_gift_bar", "1")
    } else if (override === "0" || override === "false") {
      sessionStorage.removeItem("promo_gift_bar")
    } else if (sessionStorage.getItem("promo_gift_bar") === "1") {
      override = "1"
    }
  } catch (e) {
    // private mode / storage disabled — the param still works for this page
  }

  if (override === "1" || override === "true") {
    enabled = true
  } else if (override === "0" || override === "false") {
    enabled = false
  }

  // window.PromoGift (king-promo-gift-config) has the final say: it adds the
  // end date and the sold-out check to the switch and the QA override above.
  if (window.PromoGift) {
    enabled = window.PromoGift.active()
  }

  // Fallback for the multi-box variants that carry no SKU — the box count is
  // read out of the variant title instead. Compiled once; a bad pattern just
  // disables the fallback rather than taking the cart down with it.
  let multiBoxRe = null
  if (config.multiBoxTitlePattern) {
    try {
      multiBoxRe = new RegExp(config.multiBoxTitlePattern, "i")
    } catch (e) {
      console.warn("[promo gift] bad multiBoxTitlePattern:", e)
    }
  }

  // Variants that are in the cart but are not product spend — the Expedited
  // Shipping line, chiefly. Only consulted in spend mode.
  const excludeVariantIds = (
    Array.isArray(config.excludeVariantIds) ? config.excludeVariantIds : []
  ).map((id) => String(id).trim())

  // Spend tiers, lowest goal first. A config from before tiers existed carries
  // one goalCents + spendUnlockedMessage + spendNote, which reads as a one-tier
  // list. A repeated goal is dropped: its gift lines would carry the same
  // _promo_gift tag, and Shopify would merge them into one line.
  const spendTiers = (
    Array.isArray(config.spendTiers) && config.spendTiers.length > 0
      ? config.spendTiers
      : [
          {
            goalCents: config.goalCents,
            message: config.spendUnlockedMessage,
            note: config.spendNote,
          },
        ]
  )
    .map((tier) => ({
      goalCents: Number(tier.goalCents) > 0 ? Number(tier.goalCents) : 15000,
      message: tier.message || "You unlocked your free gift!",
      note: tier.note || "",
    }))
    .sort((a, b) => a.goalCents - b.goalCents)
    .filter((tier, i, tiers) => i === 0 || tier.goalCents !== tiers[i - 1].goalCents)

  // The visitor's threshold (A/B test, HCP lock) — see window.PromoGift. Only a
  // one-tier promo can be moved; with several tiers there is no single goal.
  if (window.PromoGift && spendTiers.length === 1) {
    spendTiers[0].goalCents = window.PromoGift.goalCents()
  }

  let stepLabel = config.stepLabel || "FMD"
  _promoGiftConfigCache = {
    enabled: enabled && gifts.length > 0,
    // "spend" unlocks on cart subtotal, "qty" on qualifying box count. Anything
    // else falls back to "qty", which is what every older config meant.
    mode: config.mode === "spend" ? "spend" : "qty",
    spendTiers: spendTiers,
    // The first tier — the spend at which the promo counts as unlocked.
    goalCents: spendTiers[0].goalCents,
    // Which subtotal the goal is measured against: "original" (list prices, the
    // basis the free-shipping bar already uses) or "final" (after discounts).
    spendBasis: config.spendBasis === "final" ? "final" : "original",
    excludeVariantIds: excludeVariantIds,
    spendLockedMessage:
      config.spendLockedMessage ||
      "You're ${remaining} away from your free gift!",
    // The line under the bar before the first tier is reached.
    spendNote: config.spendNote || "",
    // The bar is a separate switch from the promo itself: showBar: false runs
    // the gift auto-add silently and leaves the free-shipping bar on screen.
    // Defaults to true so an older config that only sets `enabled` still gets
    // the bar it used to get.
    showBar: config.showBar !== false,
    goalQty: Number(config.goalQty) > 0 ? Number(config.goalQty) : 2,
    qualifyingProductIds: productIds,
    boxCounts: boxCounts,
    multiBoxRe: multiBoxRe,
    title: config.title || "Do the 5-Day together, and <b>receive more</b>",
    subtitle: config.subtitle || "",
    note: config.note || "Gifts added automatically",
    stepLabel: stepLabel,
    stepLabelPlural: config.stepLabelPlural || stepLabel + "s",
    allUnlockedMessage: config.allUnlockedMessage || "🎉 All gifts unlocked",
    bubbleMs: Number(config.bubbleMs) > 0 ? Number(config.bubbleMs) : 3000,
    gifts: gifts,
  }
  return _promoGiftConfigCache
}

/**
 * VARIANT B of the gift-image A/B test: pictures out of the row, revealed as
 * bubbles instead. The assignment itself lives in window.__promoGiftBubblesOn()
 * (snippets/king-promo-gift-config.liquid), which an experiment tool drives by
 * setting window.PROMO_GIFT_BUBBLES on each page load. Resolved on every call,
 * never cached and never persisted, so stopping the test puts everyone back on
 * the control design with nothing left behind.
 */
function promoGiftBubblesOn() {
  return !!(window.__promoGiftBubblesOn && window.__promoGiftBubblesOn())
}

// Pending fade-out timers, keyed by tier index. Kept outside the component so a
// re-reveal can cancel its own timer without the timer ids becoming reactive
// state that re-renders the bar.
const promoGiftBubbleTimers = {}
function clearPromoGiftBubbleTimer(index) {
  if (promoGiftBubbleTimers[index]) {
    clearTimeout(promoGiftBubbleTimers[index])
    delete promoGiftBubbleTimers[index]
  }
}

// Line property stamped on every promo gift line. Everything downstream keys off
// this instead of the variant id, so a shopper who *buys* one of these products
// at full price is never mistaken for a gift and never touched.
const PROMO_GIFT_PROPERTY = "_promo_gift"

function isPromoGiftLine(item) {
  return !!(item && item.properties && item.properties[PROMO_GIFT_PROPERTY])
}

/**
 * Loop Subscriptions preset bundles (assets/loop-widget-custom.js) do not add
 * one bundle line: every product inside the bundle becomes its own cart line,
 * stamped with `_bundleId` (shared by the whole bundle) and `bundleName` /
 * `_bundleName`. Rendered as-is, the drawer shows loose child products with no
 * bundle title, which reads as a broken cart.
 * 
 * groupLoopBundleLines() folds every line sharing a `_bundleId` into ONE display
 * row titled with the bundle name. The row carries the real lines in
 * `bundle_lines` and lists them through the same has_components /
 * bundle_components UI a native Shopify bundle uses. It is display-only: cart
 * mutations still go to the child lines (see removeItem), and quantity is not
 * shown or editable: Loop's bundle discount attribute is computed for the
 * quantity the bundle was added with.
 *
 * Every returned line gets `line` = its index in the ORIGINAL items array.
 */
const LOOP_BUNDLE_ID_PROPERTY = "_bundleId"

function loopBundleId(item) {
  return (item && item.properties && item.properties[LOOP_BUNDLE_ID_PROPERTY]) || null
}

function groupLoopBundleLines(items) {
  if (!items || items.length === 0) return items
  let result = []
  let groups = {}

  items.forEach((line, i) => {
    line.line = i
    let bundleId = loopBundleId(line)
    if (!bundleId) {
      result.push(line)
      return
    }
    if (!groups[bundleId]) {
      groups[bundleId] = []
      // Placeholder keeps the bundle where its first child sat in the cart
      result.push(bundleId)
    }
    groups[bundleId].push(line)
  })

  return result.map((entry) => {
    if (typeof entry !== "string") return entry
    let lines = groups[entry]
    let first = lines[0]
    let name =
      (first.properties && (first.properties.bundleName || first.properties._bundleName)) ||
      first.product_title
    let sum = (field) => lines.reduce((total, l) => total + (l[field] || 0), 0)

    let discounts = []
    lines.forEach((l) => {
      ;(l.discounts || []).forEach((d) => {
        let existing = discounts.find((x) => x.title === d.title)
        if (existing) {
          existing.amount += d.amount
        } else {
          discounts.push({ title: d.title, amount: d.amount })
        }
      })
    })

    return Vue.reactive({
      is_loop_bundle: true,
      bundle_id: entry,
      bundle_lines: lines,
      key: `loop-bundle:${entry}`,
      line: first.line,
      title: name,
      product_title: name,
      variant_title: null,
      handle: null,
      sku: null,
      url: null,
      image: first.image,
      // Bundle count is not recoverable from child quantities (2 bundles of
      // 1 bar reads the same as 1 bundle of 2 bars), so the row has none; the
      // child list shows the real per-product quantities.
      quantity: 1,
      price: sum("original_line_price"),
      original_line_price: sum("original_line_price"),
      final_line_price: sum("final_line_price"),
      discounts: discounts,
      properties: {},
      selling_plan_allocation: first.selling_plan_allocation,
      has_components: true,
      bundle_components: lines.map((l) => ({
        quantity: l.quantity,
        product_title: l.product_title,
        variant_title: l.variant_title || "",
        featured_image: l.image,
      })),
      removing: lines.some((l) => l.removing),
    })
  })
}

/**
 * How many FMD boxes one cart line is worth. 0 means the line is not an FMD.
 *
 * Two rules, in order:
 *  1. the SKU, matched EXACTLY — never a prefix, because "PR001(2) - Day 1 Assy"
 *     is a $35 single-day box, not a 5-day FMD, and a prefix would count it;
 *  2. the variant title, for the multi-box variants Shopify gives no SKU at all
 *     ("Original / 2x Prolon", "Gen3 / 3x Prolon" — blank SKU, one line, qty 1,
 *     worth 2 or 3 boxes). Without this the cart read them as zero and the
 *     shopper never got the gifts.
 */
function promoGiftBoxesPerUnit(item) {
  let config = resolvePromoGiftConfig()
  let bySku = config.boxCounts[String(item.sku || "").trim().toUpperCase()]

  // Product-specific promo (qualifyingProductIds set): the product decides,
  // not the SKU. Any variant of a named product counts — so 2 units of it in
  // any mix (2x Original, or 1 Original + 1 Gen3, one line or two) reach a
  // goal of 2 — and everything else in the store counts for nothing, even when
  // it shares the SKU. A unit is worth one box unless a bundle SKU or a
  // "2x Prolon" title says it ships more.
  if (config.qualifyingProductIds.length > 0) {
    if (config.qualifyingProductIds.indexOf(String(item.product_id)) === -1) {
      return 0
    }
    if (bySku) {
      return bySku
    }
    if (config.multiBoxRe) {
      let hit = config.multiBoxRe.exec(
        String(item.variant_title || item.title || "")
      )
      if (hit) {
        return Number(hit[1]) || 1
      }
    }
    return 1
  }

  if (bySku) {
    return bySku
  }
  if (config.multiBoxRe) {
    let match = config.multiBoxRe.exec(
      String(item.variant_title || item.title || "")
    )
    if (match) {
      return Number(match[1]) || 0
    }
  }
  return 0
}

/**
 * SPEND MODE — how much of the cart counts towards the $ goal, in cents.
 *
 * Two kinds of line are left out:
 *  - gift lines, so a gift can never help pay for itself (they are $0 anyway,
 *    but the rule holds if a gift ever carries a price);
 *  - anything in `excludeVariantIds` — the Expedited Shipping line is a
 *    shipping upgrade, not a purchase, and must not count towards a spend goal.
 *
 * `spendBasis` picks which price is read: "original" is the line's list price
 * (what the free-shipping milestone bar in this cart already runs on), "final"
 * is what the shopper actually pays after selling-plan and automatic discounts.
 */
function promoGiftQualifyingCents(cart) {
  if (!cart || !Array.isArray(cart.items)) {
    return 0
  }
  let config = resolvePromoGiftConfig()
  let useFinal = config.spendBasis === "final"

  return cart.items.reduce(function (sum, item) {
    if (isPromoGiftLine(item)) {
      return sum
    }
    if (config.excludeVariantIds.indexOf(String(item.variant_id)) !== -1) {
      return sum
    }
    // Shopify sends both on every line; the fallbacks are only there so a
    // trimmed-down cart payload can never make the bar read zero.
    let price = useFinal
      ? item.final_line_price != null
        ? item.final_line_price
        : item.line_price
      : item.original_line_price != null
      ? item.original_line_price
      : item.line_price
    return sum + (Number(price) || 0)
  }, 0)
}

/**
 * The one question both the bar and the auto-add ask, answered in one place so
 * they can never disagree: does this cart qualify for the gifts?
 */
function promoGiftIsUnlocked(cart) {
  let config = resolvePromoGiftConfig()
  if (config.mode === "spend") {
    return promoGiftQualifyingCents(cart) >= config.goalCents
  }
  return promoGiftQualifyingQty(cart) >= config.goalQty
}

/**
 * SPEND MODE — how many tiers this cart has reached: 0 below the first, 1 from
 * the first tier's goal, and so on. The tiers are sorted, so it is a count.
 */
function promoGiftSpendTierCount(cart) {
  let config = resolvePromoGiftConfig()
  let spend = promoGiftQualifyingCents(cart)
  return config.spendTiers.filter((tier) => spend >= tier.goalCents).length
}

/**
 * The gift lines this cart has earned, one entry per cart line: the variant,
 * and the _promo_gift tag that tells its line apart from the others.
 *
 * Spend mode earns one line of every gift per tier reached, tagged with that
 * tier's goal ("7500", "20000"). Qty mode earns one line of each gift, tagged
 * with the box goal. The tag is the property value the line is added with, so
 * two tiers of the same gift land as two lines instead of Shopify merging them.
 */
function promoGiftEarnedLines(cart) {
  let config = resolvePromoGiftConfig()
  let tags = []
  if (config.mode === "spend") {
    tags = config.spendTiers
      .slice(0, promoGiftSpendTierCount(cart))
      .map((tier) => String(tier.goalCents))
  } else if (promoGiftIsUnlocked(cart)) {
    tags = [String(config.goalQty)]
  }

  let lines = []
  tags.forEach((tag) => {
    config.gifts.forEach((gift) => {
      gift.variantIds.forEach((variantId) => {
        lines.push({ variantId: String(variantId), tag: tag })
      })
    })
  })
  return lines
}

// Whether a promo gift line in the cart is the one an earned entry stands for.
function isPromoGiftLineFor(line, earned) {
  return (
    String(line.variant_id) === earned.variantId &&
    String(line.properties[PROMO_GIFT_PROPERTY]) === earned.tag
  )
}

/**
 * How many FMD boxes are in the cart — the number the QTY promo turns on.
 * Gift lines are skipped, so a gift can never help pay for itself.
 */
function promoGiftQualifyingQty(cart) {
  if (!cart || !Array.isArray(cart.items)) {
    return 0
  }
  return cart.items.reduce(function (count, item) {
    if (isPromoGiftLine(item)) {
      return count
    }
    return count + promoGiftBoxesPerUnit(item) * (Number(item.quantity) || 0)
  }, 0)
}

// Variants Shopify refused this page-load, mapped to the reason. Stops the
// auto-add retrying a sold-out gift on every cart change, and feeds
// window.promoGiftDebug().
const promoGiftAddFailures = {}

// Entries appended to the _free_gift_above_subtotal cart attribute — the
// server-side rule that zeroes a gift above a spend threshold. This promo needs
// no entry even in spend mode: its gift variants are already $0.00 in Shopify,
// so there is nothing to zero and the list stays empty.
function promoGiftDiscountEntries() {
  return []
}

/**
 * Console diagnostic for the promo. Run window.promoGiftDebug() in the browser
 * console to see how many FMD boxes the cart is counting, which lines it counted
 * them from, and — per gift — whether it is in the cart and why an add failed.
 */
window.promoGiftDebug = function () {
  let config = resolvePromoGiftConfig()
  let cart = (store.state.cartState && store.state.cartState[0]) || null

  console.log("=== promo gift bar ===")
  console.log("mode:", config.mode)
  console.log("enabled:", config.enabled, "(window.PROMO_GIFT_BAR.enabled =",
    (window.PROMO_GIFT_BAR || {}).enabled, ", session override =",
    (function () { try { return sessionStorage.getItem("promo_gift_bar") } catch (e) { return "n/a" } })(), ")")

  if (!cart) {
    console.log("no cart loaded yet — open the cart and run this again")
    return
  }

  let unlocked = promoGiftIsUnlocked(cart)
  let money = (cents) => `$${((Number(cents) || 0) / 100).toFixed(2)}`

  if (config.mode === "spend") {
    let spend = promoGiftQualifyingCents(cart)
    console.log(`spend basis: ${config.spendBasis} line prices`)
    console.log(`qualifying spend: ${money(spend)}`)
    config.spendTiers.forEach((tier) =>
      console.log(
        `  tier ${money(tier.goalCents)} —`,
        spend >= tier.goalCents
          ? "REACHED"
          : `locked, ${money(tier.goalCents - spend)} to go`
      )
    )
    console.log("counted from:", (cart.items || [])
      .filter(
        (item) =>
          !isPromoGiftLine(item) &&
          config.excludeVariantIds.indexOf(String(item.variant_id)) === -1
      )
      .map((item) =>
        `${item.sku || "(no sku)"} "${item.variant_title || item.title}" x${
          item.quantity
        } = ${money(
          config.spendBasis === "final"
            ? item.final_line_price
            : item.original_line_price
        )}`))
    console.log("excluded variants:", config.excludeVariantIds.join(", ") || "(none)")
  } else {
    let qty = promoGiftQualifyingQty(cart)
    console.log(
      "qualifying product ids:",
      config.qualifyingProductIds.length
        ? config.qualifyingProductIds.join(", ") +
            " (only these products count; SKUs alone do not)"
        : "(none — counting by SKU)"
    )
    console.log(
      `qualifying FMD boxes: ${qty} / ${config.goalQty} —`,
      unlocked ? "UNLOCKED" : "locked"
    )
    console.log("counted from:", (cart.items || [])
      .filter((item) => !isPromoGiftLine(item) && promoGiftBoxesPerUnit(item))
      .map((item) =>
        `${item.sku || "(no sku)"} "${item.variant_title || item.title}" x${
          item.quantity
        } = ${promoGiftBoxesPerUnit(item) * item.quantity} box(es)`))
  }

  // One row per gift line the promo can put in the cart — per tier, in spend
  // mode — whether or not this cart has earned it yet.
  let tags =
    config.mode === "spend"
      ? config.spendTiers.map((tier) => String(tier.goalCents))
      : [String(config.goalQty)]
  let earnedLines = promoGiftEarnedLines(cart)
  console.table(
    tags.reduce(function (rows, tag) {
      config.gifts.forEach(function (gift) {
        gift.variantIds.forEach(function (variantId) {
          let slot = { variantId: String(variantId), tag: tag }
          let line = (cart.items || []).find(
            (item) => isPromoGiftLine(item) && isPromoGiftLineFor(item, slot)
          )
          let removed = null
          try {
            removed = Cookies.get(`rrremoved_${variantId}`)
          } catch (e) {}
          rows.push({
            tile: gift.gift,
            tier: config.mode === "spend" ? money(tag) : tag + " boxes",
            variantId: variantId,
            earned: earnedLines.some(
              (earned) => earned.variantId === slot.variantId && earned.tag === tag
            ),
            giftInCart: line ? "yes (qty " + line.quantity + ")" : "no",
            shopperRemoved: removed === "true" ? "yes" : "no",
            addError: promoGiftAddFailures[variantId] || "",
          })
        })
      })
      return rows
    }, [])
  )
  console.log(
    "cart lines:",
    (cart.items || []).map(
      (item) =>
        `${item.variant_id} [${item.sku || "no sku"}] product:${
          item.product_id
        } qty${item.quantity} ${
          isPromoGiftLine(item) ? "[PROMO GIFT]" : ""
        } ${item.title}`
    )
  )
  return "run store.checkCart() to force a re-check"
}

if (document.querySelector("#cart-with-header")) {
  const headerCart = Vue.createApp({
    delimiters: ["${", "}"],
    data() {
      let providerCode = localStorage.getItem("provider_code")
      let discountCode = getParam("discount") || local_discount_code || ""
      if ((discountCode && discountCode == "null") || discountCode == null) {
        discountCode = ""
      }
      if (providerCode && providerCode == "null") {
        providerCode = ""
      }

      if (providerCode) {
        // freeShippingSettings.freeShippingThreshold = 10000;
      }

      let promoGiftConfig = resolvePromoGiftConfig()

      return {
        cartData: store.state.cartState,
        scrollY: 0,
        custom_loading: false,
        hasValidStripeProducts: true,
        isOpeningMenu: false,
        checkoutLoading: false,
        discountCode: discountCode,
        allowedGifts: store.state.allowedGifts,
        provider_code: providerCode,
        addingDiscount: false,

        new_year_bundle: {
          id: 8336799989918,
          loading: false,
          variants: [
            {
              id: 45631937183902,
            },
          ],
          handle: "longevity-nutrition-kit",
        },
        new_year_bundle_v2: {
          id: 8336799989918,
          loading: false,
          variants: [
            {
              id: 45631937183902,
            },
          ],
          handle: "longevity-nutrition-kit",
        },
        prolon_protein: {
          id: null,
          loading: false,
          variants: [
            {
              id: 43123983679646,
            },
          ],
          handle: "l-protein",
        },
        ShowDiscountFailedMessage: false,

        // leanCart picks which slide-cart shell renders inside #cart-with-header
        // (snippets/cart-drawer.liquid): the lean redesign or the original. The
        // lean design is the default now; the decision lives in
        // window.__leanCartOn() — see snippets/king-slide-cart-lean-css.liquid.
        // Nothing is persisted, so a visitor only sees the original cart while
        // something is explicitly asking for it (window.LEAN_CART = false, or a
        // QA override in this tab).
        leanCart: !!(window.__leanCartOn && window.__leanCartOn()),

        // leanVariant is the A/B arm INSIDE the lean cart (1/2/3). It only
        // decides which optional sections render — see lcShowExpedited /
        // lcShowRecommendations below and window.__leanCartVariant() in
        // snippets/king-slide-cart-lean-css.liquid. Nothing is persisted.
        leanVariant: (window.__leanCartVariant && window.__leanCartVariant()) || 1,
         milestones: [
          // {
          //   id: "free_gift",
          //   amount: 100, 
          //   label: "Free Gift",
          //   icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/gift_1.png?v=1762806712",
          //   achievedIcon:
          //     "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/gift_2.png?v=1762806751",
          //   achievedMessage: "🎉 You've earned a free gift!",
          //   pendingMessage:
          //     "${remainingAmount} away from free gift",
          //   beforeText: "Free Gift —",
          //   afterText: "on orders over $99",
          // }, 
          {
            id: "free_shipping",
            amount: 199,
            label: "Free Shipping",
            icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/free-shipping.png?v=1751369542",
            achievedIcon:
              "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/free-shipping.png?v=1751369542",
            achievedMessage: "🎉 You've earned free shipping!",
            pendingMessage:
              "${remainingAmount} away from free shipping",
            beforeText: "Free Shipping —",
            afterText: "on orders over $199",
          },
          // {
          //   id: "discount_30",
          //   amount: 250, 
          //   label: "Save 30%",
          //   icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/Frame_52_4.png?v=1750420498",
          //   achievedIcon:
          //     "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/30OFF.png?v=1750452929",
          //   achievedMessage: "🎉 You have earned 30% discount!",
          //   pendingMessage: "${remainingAmount} away from 30% discount",
          //   beforeText: "Save 30% —",
          //   afterText: "on orders over $250",
          // },
          // {
          //   id: "discount_35", 
          //   amount: 350, 
          //   label: "Save 35%",
          //   icon: "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/35OFF-removebg-preview.png?v=1764160912",
          //   achievedIcon:
          //     "https://cdn.shopify.com/s/files/1/0508/0625/9870/files/35OFF_achived-removebg-preview.png?v=1764160912", 
          //   achievedMessage: "🎉 You have earned 35% discount!",
          //   pendingMessage: "${remainingAmount} away from 35% discount",
          //   beforeText: "Save 35% —",
          //   afterText: "on orders over $350",
          // },
        ],    
        // Promo gift bar — see resolvePromoGiftConfig() and the promoGift* methods.
        // promoGiftBar is the flag that decides which progress bar the slide
        // cart renders. It needs BOTH switches in king-promo-gift-config.liquid:
        // `enabled` runs the promo (gifts auto-added), `showBar` decides whether
        // its progress bar replaces the free-shipping bar. With showBar: false
        // the gifts still drop into the cart, silently.
        promoGiftBar: promoGiftConfig.enabled && promoGiftConfig.showBar,
        promoGiftConfig: promoGiftConfig,
        promoGiftGifts: promoGiftConfig.gifts,
        // Which of the two bars renders: the continuous $ track (spend) or the
        // stepped one-node-per-box track (qty). See king-promo-gift-progress-bar.
        promoGiftSpendMode: promoGiftConfig.mode === "spend",
        // A/B test on the gift images: false = control (images inline in the
        // row), true = variant B (images out of the row, revealed as bubbles).
        // Re-resolved when the drawer opens, because data() can run before the
        // bucketer has assigned. See promoGiftBubblesOn().
        promoGiftBubbles: promoGiftBubblesOn(),
        promoGiftBubbleShown: promoGiftConfig.gifts.map(() => false),
        expeditedShippingEnabled: false,
        giftRemovalPopup: {
          show: false,
          item: null,
          index: null,
        },
      }
    },
    methods: {
      isNextMilestone(milestone) {
        if (!milestone || !milestone.id) {
          return false
        }

        if (this.allMilestonesAchieved()) {
          return false
        }

        let cartTotal = this.original_total_price / 100
        let unachievedMilestones = this.milestones
          .filter((m) => !this.milestoneAchieved(m))
          .sort((a, b) => a.amount - b.amount)

        if (unachievedMilestones.length > 0) {
          return milestone.id === unachievedMilestones[0].id
        }

        return false
      },
      allMilestonesAchieved() {
        return this.milestones.every((m) => this.milestoneAchieved(m))
      },

      getMilestoneDiscountPercent() {
        let cartTotal = this.original_total_price / 100

        if (cartTotal >= 300) {
          return 30
        } else if (cartTotal >= 259) {
          return 25
        } else if (cartTotal >= 199) {
          return 20
        } else if (cartTotal >= 149) {
          return 15
        }

        if (
          this.provider_code &&
          this.provider_code != "null" &&
          this.provider_code != ""
        ) {
          return 30 // Default discount for provider code
        }

        return 0 // No discount
      },

      getMilestoneDiscount() {
        let discountPercent = this.getMilestoneDiscountPercent()

        if (discountPercent > 0) {
          return this.original_total_price * (discountPercent / 100)
        }

        return 0
      },

      milestoneAchieved(milestone) {
        let cartTotal = this.original_total_price / 100
        let amount = milestone.amount
        if (amount == 0) {
          return false
        }

        if (
          this.provider_code &&
          this.provider_code != "null" &&
          this.provider_code != ""
        ) {
          return true // If provider code is set, milestone is considered achieved
        }
        // Subscriptions already ship free — an all-subscription cart clears the
        // shipping milestone at any subtotal (see allLinesSubscription). Other
        // milestones (gifts, % discounts) stay on their $ thresholds.
        if (milestone.id === "free_shipping" && this.allLinesSubscription()) {
          return true
        }
        if (cartTotal >= amount) {
          return true
        } else {
          return false
        }
      },
      calculateProgress(currentAmount, shift) {
        // Dynamically find the highest milestone amount
        const maxThreshold = Math.max(...this.milestones.map((m) => m.amount))
        const minThreshold = 0 // Set minimum threshold to $100

        if (
          this.provider_code &&
          this.provider_code != "null" &&
          this.provider_code != ""
        ) {
          return 100 // If provider code is set, progress is always 100%
        }

        // All-subscription cart: every milestone is cleared, so fill the track.
        // Guarded on !shift because the milestone markers call this with their
        // own amount to get a position and must keep their real spots.
        if (!shift && this.allLinesSubscription() && this.allMilestonesAchieved()) {
          return 100
        }

        if (currentAmount <= 0) {
          return 0 // Progress is 0% if no amount is spent
        } else if (currentAmount < minThreshold) {
          // Show minimal progress for amounts under $100
          return (currentAmount / maxThreshold) * 15 // Show only up to 15% of progress bar
        } else if (currentAmount < maxThreshold) {
          // Calculate percentage from $100 to max threshold
          const adjustedAmount = currentAmount - minThreshold
          const adjustedMax = maxThreshold - minThreshold
          // Scale from 15% to 100% for the remaining range
          return 15 + (adjustedAmount / adjustedMax) * 85
        } else {
          if (shift) {
            return 97 // Slight adjustment to position the marker
          }
          return 100 // Progress is 100% if max threshold or more is spent
        }
      },

      /* ---------------- Promo gift progress bar ---------------- */

      // FMD boxes in the cart — the number the whole promo turns on. Uses the
      // same helper as the auto-add logic, so the bar and the cart can never
      // disagree about whether the gifts are unlocked.
      promoGiftQty() {
        let cart = this.cartData && this.cartData[0]
        return cart ? promoGiftQualifyingQty(cart) : 0
      },

      promoGiftGoal() {
        return Number(this.promoGiftConfig.goalQty) || 2
      },

      // [1, 2, …] — one node on the track per box needed.
      promoGiftSteps() {
        let steps = []
        for (let i = 1; i <= this.promoGiftGoal(); i++) {
          steps.push(i)
        }
        return steps
      },

      promoGiftUnitLabel(count) {
        return Number(count) === 1
          ? this.promoGiftConfig.stepLabel
          : this.promoGiftConfig.stepLabelPlural
      },

      promoGiftStepLabel(step) {
        return `${step} ${this.promoGiftUnitLabel(step)}`
      },

      // Where a step's node sits on the track: box 1 of 2 is at 50%, box 2 at
      // 100%. The track therefore starts empty and each box fills one share.
      promoGiftStepPct(step) {
        let goal = this.promoGiftGoal()
        return goal > 0 ? (Number(step) / goal) * 100 : 0
      },

      // Fill follows the same scale as the nodes, so it always stops exactly on
      // the last box the shopper has in the cart.
      promoGiftPct() {
        let goal = this.promoGiftGoal()
        let reached = Math.max(0, Math.min(goal, this.promoGiftQty()))
        return goal > 0 ? (reached / goal) * 100 : 0
      },

      promoGiftUnlocked() {
        let cart = this.cartData && this.cartData[0]
        return cart ? promoGiftIsUnlocked(cart) : false
      },

      /* ---------------- Spend mode ---------------- */

      // Cart spend counting towards the goal, in cents. Same helper the
      // auto-add uses, so the bar and the cart can never disagree.
      promoGiftSpendCents() {
        let cart = this.cartData && this.cartData[0]
        return cart ? promoGiftQualifyingCents(cart) : 0
      },

      // Tiers reached so far — same helper as the auto-add, so the copy always
      // matches the gift lines in the cart.
      promoGiftSpendReached() {
        let cart = this.cartData && this.cartData[0]
        return cart ? promoGiftSpendTierCount(cart) : 0
      },

      // Distance to the next tier still to reach; 0 once the top one is.
      promoGiftSpendRemainingCents() {
        let next = this.promoGiftConfig.spendTiers[this.promoGiftSpendReached()]
        return next ? Math.max(0, next.goalCents - this.promoGiftSpendCents()) : 0
      },

      // The track runs to the top tier; the tiers below it sit on it as nodes.
      promoGiftSpendPct() {
        let tiers = this.promoGiftConfig.spendTiers
        let goal = tiers[tiers.length - 1].goalCents
        if (!(goal > 0)) {
          return 0
        }
        return Math.min(100, (this.promoGiftSpendCents() / goal) * 100)
      },

      // Every tier, placed where its goal falls on the track, for the nodes
      // and the amounts under it.
      promoGiftSpendMarkers() {
        let tiers = this.promoGiftConfig.spendTiers
        let goal = tiers[tiers.length - 1].goalCents
        let spend = this.promoGiftSpendCents()
        return tiers.map((tier) => ({
          goalCents: tier.goalCents,
          pct: (tier.goalCents / goal) * 100,
          label: this.promoGiftMoney(tier.goalCents),
          reached: spend >= tier.goalCents,
        }))
      },

      // "$62.50", but "$50" when the amount is whole dollars — a trailing .00
      // in a headline reads like a price tag, not a distance to go.
      promoGiftMoney(cents) {
        let dollars = (Number(cents) || 0) / 100
        return dollars % 1 === 0
          ? `$${dollars.toFixed(0)}`
          : `$${dollars.toFixed(2)}`
      },

      // Fills ${remaining} with the distance to the next tier and ${goal} with
      // the first tier's amount (the visitor's threshold).
      promoGiftSpendFill(text) {
        // Function replacer, not a string one: the amount starts with "$", and
        // String.replace reads $-sequences in a *string* replacement as
        // substitution patterns. A function is handed through verbatim.
        let remaining = this.promoGiftMoney(this.promoGiftSpendRemainingCents())
        let goal = this.promoGiftMoney(this.promoGiftConfig.goalCents)
        return String(text || "")
          .replace("${remaining}", () => remaining)
          .replace("${goal}", () => goal)
      },

      // Headline and note both follow the highest tier reached; before the
      // first, the locked copy.
      promoGiftSpendMessage() {
        let reached = this.promoGiftSpendReached()
        return this.promoGiftSpendFill(
          reached > 0
            ? this.promoGiftConfig.spendTiers[reached - 1].message
            : this.promoGiftConfig.spendLockedMessage
        )
      },

      promoGiftSpendNote() {
        let reached = this.promoGiftSpendReached()
        return this.promoGiftSpendFill(
          reached > 0
            ? this.promoGiftConfig.spendTiers[reached - 1].note
            : this.promoGiftConfig.spendNote
        )
      },

      /* -------------------------------------------- */

      // Drops the cached promo config, re-reads it (goal, on/off) and re-syncs
      // the gift lines in the cart to it.
      promoGiftRefresh() {
        _promoGiftConfigCache = null
        let config = resolvePromoGiftConfig()
        this.promoGiftConfig = config
        this.promoGiftBar = config.enabled && config.showBar
        // The banner's threshold too (an HCP code locks it back to $200).
        if (window.PromoGift) window.PromoGift.paint()
        store.recheckPromoGifts()
      },

      promoGiftRemainingQty() {
        return Math.max(0, this.promoGiftGoal() - this.promoGiftQty())
      },

      // Combined MSRP of the gift set, shown in the status line and the strip
      // under the tiles so the number is never hard-coded in two places.
      promoGiftTotalValue() {
        return this.promoGiftGifts.reduce(
          (sum, gift) => sum + (Number(gift.msrp) || 0),
          0
        )
      },

      promoGiftStatusMessage() {
        if (this.promoGiftUnlocked()) {
          return this.promoGiftConfig.allUnlockedMessage
        }
        let left = this.promoGiftRemainingQty()
        let unit = this.promoGiftUnitLabel(left)
        // "Add 2 FMDs" on an empty cart, "Add 1 more FMD" once one is in.
        let ask = this.promoGiftQty() > 0 ? `${left} more ${unit}` : `${left} ${unit}`
        return `Add <b>${ask}</b> to unlock $${this.promoGiftTotalValue()} in free gifts`
      },

      /* --------- Promo gift images, variant B (reveal bubbles) --------- */

      promoGiftBubbleOn(index) {
        return !!this.promoGiftBubbleShown[index]
      },

      // Open one bubble and queue its fade-out. Re-opening an already-open
      // bubble restarts the countdown instead of stacking a second timer.
      promoGiftShowBubble(index, delay) {
        if (!this.promoGiftBubbles || !this.promoGiftGifts[index]) {
          return
        }
        clearPromoGiftBubbleTimer(index)
        const open = () => {
          this.promoGiftBubbleShown[index] = true
          promoGiftBubbleTimers[index] = setTimeout(() => {
            this.promoGiftBubbleShown[index] = false
            delete promoGiftBubbleTimers[index]
          }, this.promoGiftConfig.bubbleMs)
        }
        if (delay > 0) {
          // Not tracked as a fade-out timer: the stagger delay is short and
          // open() takes over the slot the moment it runs.
          setTimeout(open, delay)
        } else {
          open()
        }
      },

      // Every bubble pops when the cart opens, staggered so they read as a
      // sequence rather than one block appearing.
      promoGiftRevealAllBubbles() {
        if (!this.promoGiftBubbles) {
          return
        }
        this.promoGiftGifts.forEach((gift, i) => {
          this.promoGiftShowBubble(i, i * 120)
        })
      },

      // Tapping a gift name pops that one bubble again.
      promoGiftRevealGift(index) {
        if (!this.promoGiftBubbles) {
          return
        }
        this.promoGiftShowBubble(index, 0)
      },

      promoGiftHideAllBubbles() {
        this.promoGiftGifts.forEach((gift, i) => {
          clearPromoGiftBubbleTimer(i)
          this.promoGiftBubbleShown[i] = false
        })
      },

      /* -------------------------------------------------------- */

      getMiniDescription(id) {
        return (
          (window.gift_products_mini_description &&
            window.gift_products_mini_description[id]) ||
          ""
        )
      },
      bundle_items(item) {
        let finalHtml = ""
        try {
          let shopify_cartItems = store.state.shopify_cart
          let shopifyItem = shopify_cartItems.find(
            (i) => i.handle === item.handle
          )
          let bundleItems = shopifyItem.bundle_items
          if (bundleItems && bundleItems.length > 0) {
            let bundleQuantityString =
              shopifyItem?.custom_metafields?.prolon_bundle_item_quantity
            let bundleQuantity
            if (bundleQuantityString) {
              bundleQuantity = bundleQuantityString.split(",")
            }
            //  for loop for bundle items and bundle quantity
            for (let i = 0; i < bundleItems.length; i++) {
              let currentQuantity = bundleQuantity[i]
              let currentBundleItem = bundleItems[i]
              let bundleTitle = currentBundleItem.title
              let bundleName = currentBundleItem?.name?.replace(
                " - " + bundleTitle,
                ""
              )
              let bundleImage = currentBundleItem.featured_image?.src
              let bundleImageHtml = `<img src="${bundleImage}" class="w-8 h-8 object-cover" alt="">`
              if (!bundleImage) {
                bundleImageHtml = `<div class="w-8 h-8 object-cover" >${window.placeholder_image_svg}</div>`
              }

              finalHtml += `<div class="flex flex-row justify-between items-center py-2 pl-2 md:pl-5">
          <div class="flex flex-row justify-start items-center">
          <div class="w-8 h-8 border border-solid border-1 rounded">
              ${bundleImageHtml}
          </div>   
          <div class="flex flex-col justify-center items-start">
          <p class="text-[12px] pl-4 font-medium ">
          <span class="block font-semibold">
          ${currentQuantity} x ${bundleName}
          </span>
          <small>${bundleTitle}</small>
          </p>
          
          </div>
          </div></div>
          `
            }
          }
        } catch (ex) {}
        return finalHtml
      },
      bundle_component_length(item) {
        if (item.is_loop_bundle) {
          return item.bundle_components.length
        }
        let shopify_cartItems = store.state.shopify_cart
        if (!shopify_cartItems) {
          return ""
        }
        let shopifyItem = shopify_cartItems.find(
          (i) => i.handle === item.handle
        ) 
        let bundleItems = shopifyItem?.bundle_components
        if (bundleItems && bundleItems.length > 0) {
          return bundleItems.length
        } else {
          return 0
        }
      },
      bundle_components(item) {
        let finalHtml = "" 
        try {
          let bundleItems
          if (item.is_loop_bundle) {
            bundleItems = item.bundle_components
          } else {
            let shopify_cartItems = store.state.shopify_cart
            let shopifyItem = shopify_cartItems.find(
              (i) => i.handle === item.handle
            )
            bundleItems = shopifyItem.bundle_components
          }
          if (bundleItems && bundleItems.length > 0) {
            //  for loop for bundle items and bundle quantity
            for (let component of bundleItems) {
              let currentQuantity = component.quantity
              let currentBundleItem = component
              let bundleTitle = currentBundleItem.variant_title.replace(
                "Default Title",
                ""
              )
              let bundleName = currentBundleItem.product_title
              let bundleImage = currentBundleItem.featured_image
              let bundleImageHtml = `<img src="${bundleImage}" class="w-8 h-8 object-cover" alt="">`
              if (!bundleImage) {
                bundleImageHtml = `<div class="w-8 h-8 object-cover" >${window.placeholder_image_svg}</div>`
              }

              finalHtml += `<div class="flex flex-row justify-between items-center py-2 pl-2 md:pl-5">
          <div class="flex flex-row justify-start items-center">
          <div class="w-8 h-8 border border-solid border-1 rounded">
              ${bundleImageHtml}
          </div>   
          <div class="flex flex-col justify-center items-start">
          <p class="text-[12px] pl-4 font-medium ">
          <span class="block font-semibold">
          ${currentQuantity} x ${bundleName}
          </span>
          <small>${bundleTitle}</small>
          </p>
          
          </div>
          </div></div>
          `
            }
          }
        } catch (ex) {}
        return finalHtml
      },
      clearProviderCode() {
        localStorage.setItem("provider_code", null)
        Cookies.set("provider_code", null, { expires: 700 })
        this.provider_code = null
        this.discount_code = null
      },
      toggleSlideCart() {
        toggleCart.openCart()
      },
      getUpsellTagLines(handle) {
        let tagsLines = {
          "fasting-shake-upsell": [
            "Fasting Shake: Fuel Your Body, Not Your Hunger",
            "Fasting Shake: Elevate Your Nutrition Game",
            "Fasting Shake: Nourish Without Guilt",
            "Fasting Shake: Aging Slower, Feeling Better",
          ],
          "prolon-20-off": ["Continue your longevity journey"],
          "fast-bar-off": [
            "Fasting Bars: The Delicious Way to Extend Your Fasting Window",
          ],
        }

        return tagsLines[handle]
      },
      toggleMenu() {
        this.isOpeningMenu = menuState.hidden

        setTimeout(() => {
          toggleMenu.openMenu()
        }, 100)
      },
      closeAllDrawers() {
        this.isOpeningMenu = false
        toggleClose.closeAll()
      },
      removeItem(item, index, confirmed) {
        // Intercept free-gift removal so the shopper knows it won't come back today
        // Promo gift lines count as free gifts here even though their `price`
        // is the undiscounted MSRP — the discount lands later in the funnel.
        let isFreeGiftLine = item && (item.price === 0 || isPromoGiftLine(item))
        if (!confirmed && isFreeGiftLine && !item.removing && !this.giftRemovalPopup.show) {
          this.giftRemovalPopup = { show: true, item, index }
          return
        }

        item.removing = true
        devLog({ index })
        if (isFreeGiftLine) {
          try {
            Cookies.set(`rrremoved_${item.id}`, "true", { expires: 1 })
          } catch (ex) {
            console.error("Error setting cookie:", ex)
          }
        }

        // A Loop bundle row stands for several real cart lines; remove them all.
        // Matched by key, not position: the drawer's rows are grouped and
        // filtered, so a row index is not a cart line number.
        let removedKeys = item.is_loop_bundle
          ? item.bundle_lines.map((l) => l.key)
          : [item.key]
        if (item.is_loop_bundle) {
          item.bundle_lines.forEach((l) => (l.removing = true))
        }

        // Find free gifts that depend on this item being in cart so we can remove them immediately
        let giftVariantIdsToRemove = []
        let cart = store.state.cartState[0]
        const expeditedShippingVariantId = 43035645640862
        if (cart && cart.items) {
          let remainingItems = cart.items.filter((ci) => !removedKeys.includes(ci.key))

          // Auto-remove expedited shipping if only it remains after this removal
          let nonExpeditedRemaining = remainingItems.filter((ci) => ci.variant_id !== expeditedShippingVariantId)
          if (nonExpeditedRemaining.length === 0) {
            let expeditedItem = remainingItems.find((ci) => ci.variant_id === expeditedShippingVariantId)
            if (expeditedItem) {
              giftVariantIdsToRemove.push(expeditedShippingVariantId)
              expeditedItem.removing = true
              this.expeditedShippingEnabled = false
            }
          }

          store.state.allowedGifts.forEach((gift) => {
            if (!gift.enabled) return
            let giftInCart = cart.items.find((ci) => ci.variant_id == gift.variant_id)
            if (!giftInCart) return

            let wouldStillQualify = true

            // Check handle_in_cart condition
            if (gift.conditions.handle_in_cart && gift.conditions.handle_in_cart.length > 0) {
              let handleFound = remainingItems.some((ci) => gift.conditions.handle_in_cart.includes(ci.handle))
              if (!handleFound) wouldStillQualify = false
            }

            // Check skus_in condition
            if (gift.conditions.skus_in && gift.conditions.skus_in.length > 0 && gift.conditions.sku_single_item) {
              let skuFound = false
              remainingItems.forEach((ci) => {
                gift.conditions.skus_in.forEach((sku) => {
                  if (ci.sku && ci.sku.toUpperCase() === sku.toUpperCase()) {
                    let price = ci.price / 100
                    if (gift.conditions.sku_single_item.operator === ">" && price > gift.conditions.sku_single_item.value) {
                      skuFound = true
                    }
                  }
                })
              })
              if (!skuFound) wouldStillQualify = false
            }

            // Check variant_in_cart condition
            if (gift.conditions.variant_in_cart && gift.conditions.variant_in_cart.length > 0 && !gift.conditions.skus_in) {
              let variantFound = remainingItems.some((ci) => gift.conditions.variant_in_cart.includes(ci.variant_id))
              if (!variantFound) wouldStillQualify = false
            }

            // Check isSubscriptionProduct condition
            if (gift.conditions.isSubscriptionProduct === "yes") {
              let hasSubscription = remainingItems.some((ci) => ci.selling_plan_allocation && ci.selling_plan_allocation.price)
              if (!hasSubscription) wouldStillQualify = false
            }

            // Check cart_total condition against remaining items
            if (gift.conditions.cart_total) {
              let remainingTotal = remainingItems.reduce((sum, ci) => sum + ci.final_line_price, 0)
              if (gift.conditions.cart_total.operator === ">=" && remainingTotal < gift.conditions.cart_total.value) {
                wouldStillQualify = false
              }
            }

            // Check product_quantity_total condition against remaining items
            if (gift.conditions.product_quantity_total) {
              let cond = gift.conditions.product_quantity_total
              let targetHandles = cond.handles || (cond.handle ? [cond.handle] : [])
              let targetProductIds =
                cond.product_ids || (cond.product_id ? [cond.product_id] : [])
              let remainingQty = 0
              remainingItems.forEach((ci) => {
                if (ci.variant_id == gift.variant_id) return
                let matchesHandle = targetHandles.includes(ci.handle)
                let matchesProduct = targetProductIds.includes(ci.product_id)
                if (matchesHandle || matchesProduct) {
                  remainingQty += ci.quantity
                }
              })
              let stillMet
              switch (cond.operator) {
                case ">=": stillMet = remainingQty >= cond.value; break
                case ">": stillMet = remainingQty > cond.value; break
                case "==": stillMet = remainingQty == cond.value; break
                case "<=": stillMet = remainingQty <= cond.value; break
                case "<": stillMet = remainingQty < cond.value; break
                default: stillMet = false
              }
              if (!stillMet) wouldStillQualify = false
            }

            if (!wouldStillQualify) {
              giftVariantIdsToRemove.push(gift.variant_id)
              // Optimistically hide the gift item from UI
              giftInCart.removing = true
            }
          })
        }

        // If there are gifts to remove (or several bundle lines), use
        // /cart/update.js to remove everything in one call
        if (giftVariantIdsToRemove.length > 0 || removedKeys.length > 1) {
          let updates = {}
          removedKeys.forEach((key) => {
            updates[key] = 0
          })
          giftVariantIdsToRemove.forEach((variantId) => {
            let giftItem = cart.items.find((ci) => ci.variant_id == variantId)
            if (giftItem) {
              updates[giftItem.key] = 0
            }
          })
          store.setCartLoading()
          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: updates }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok")
              }
              return response.json()
            })
            .then((data) => {
              store.getCart()
            })
            .catch((error) => {
              devLog(error)
              item.removing = false
              if (item.is_loop_bundle) {
                item.bundle_lines.forEach((l) => (l.removing = false))
              }
            })
        } else {
          // No gifts to remove, proceed as normal
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: removedKeys[0], quantity: 0 }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok")
              }
              return response.json()
            })
            .then((data) => {
              store.getCart()
            })
            .catch((error) => {
              devLog(error)
              item.removing = false
              if (item.is_loop_bundle) {
                item.bundle_lines.forEach((l) => (l.removing = false))
              }
            })
        }
      },

      confirmGiftRemoval() {
        const pending = this.giftRemovalPopup
        const item = pending.item
        const index = pending.index
        this.giftRemovalPopup = { show: false, item: null, index: null }
        if (item) {
          this.removeItem(item, index, true)
        }
      },
      cancelGiftRemoval() {
        this.giftRemovalPopup = { show: false, item: null, index: null }
      },

      decrement(item, index) {
        let updateQuantity = item.quantity - 1
        item.quantity = updateQuantity
        const data = {
          id: item.key,
          quantity: updateQuantity,
        }

        item.loading_minus = true
        store.setCartLoading()
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok")
            }
            return response.json()
          })
          .then((data) => {
            store.getCart()
          })
          .catch((error) => {
            devLog(error)
            item.loading_minus = false
          })
      },
      increment(item, index) {
        let updateQuantity = item.quantity + 1
        item.quantity = updateQuantity
        const data = {
          id: item.key,
          quantity: updateQuantity,
        }

        item.loading_plus = true
        store.setCartLoading()
        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok")
            }
            return response.json()
          })
          .then((data) => {
            store.getCart()
          })
          .catch((error) => {
            devLog(error)
            item.loading_plus = false
          })
      },

      money(value) {
        if (!value) return "$0.00"
        return "$" + (value / 100).toFixed(2)
      },
      isInCart(item) {
        return (
          this.cart &&
          this.cart.items &&
          this.cart.items.find((i) => i.product_id === item.id)
        )
      },
      isInCartByHandle(item) {
        return (
          this.cart &&
          this.cart.items &&
          this.cart.items.find((i) => i?.handle?.includes(item.handle))
        )
      },
      isVariantInCart(variant_id) {
        return (
          this.cart &&
          this.cart.items &&
          this.cart.items.find((i) => i.variant_id === variant_id)
        )
      },
      isAllUpsellinCart() {
        if (this.cartData.length > 0) {
          let cartItems = this.cartData[0].items
          let upsellItems = store.state.recommendedCollection || []
          // Count upsell PRODUCTS that are in the cart, not matching cart lines:
          // one product split over two lines (one-time + subscription, or an
          // upsell line next to a gift line) used to count twice and hide the
          // whole section while other upsells were still addable.
          let upsellInCart = upsellItems.filter((product) =>
            cartItems.some((item) => item.product_id == product.id)
          ).length
          if (upsellInCart == upsellItems.length) {
            return true
          } else {
            return false
          }
        }
      },

      addToCart(item) {
        item.loading = true
        store.addToCart(item.variants[0].id, 1)
        setTimeout(() => {
          item.loading = false
        }, 2000)
      },
      addToCartWithVariantId(variant_id) {
        this.custom_loading = true
        store.addToCart(variant_id, 1, null, (response) => {
          // this.custom_loading = false;
          store.getCart()
        })
        setTimeout(() => {
          this.custom_loading = false
        }, 2000)
      },
      ABAddToCartUpsell() {
        // Check which upsell type to use based on window.change_upsell
        const upsellType = "l-protein" //window.change_upsell || 'longevity-nutrition-kit'; 
        
        if (upsellType === 'l-protein') {
          // Use prolon_protein configuration
          this.UpsellAddToCart(this.prolon_protein);
        } else {
          // Default to longevity-nutrition-kit logic
          let Xprovider_code = this.provider_code;
          
          if (Xprovider_code && Xprovider_code != "") {
            this.UpsellAddToCart(this.new_year_bundle_v2);
          } else {
            this.UpsellAddToCart(this.new_year_bundle);
          }
        }
        return;
      },
      UpsellAddToCart(item, type) {
        item.loading = true

        let props = {
          _upsell: true,
        }

        if (type == "free_gift") {
          props = {
            _free_gift: "yes",
            _above_total: window.cart_gift.threshold,
            _with_discount: "free-gifts",
            // _mystery_gift: 'yes',
          }
        }

        store.addToCartWithProperties({
          id: item.variants[0].id,
          quantity: 1,
          properties: props,
          cb: (response) => {
            item.loading = false
          },
        })
      },
      toggleExpeditedShipping() {
        this.expeditedShippingEnabled = !this.expeditedShippingEnabled
        const expeditedShippingVariantId = 43035645640862

        if (this.expeditedShippingEnabled) {
          // Add expedited shipping to cart
          store.addToCart(expeditedShippingVariantId, 1, null, (response) => {
            devLog("Expedited shipping added")
          })
        } else {
          // Remove expedited shipping from cart
          const cartItem = this.cart?.items?.find(
            (item) => item.variant_id === expeditedShippingVariantId
          )
          if (cartItem) {
            store.changeQuantity(cartItem.key, 0)
          }
        }
      },
      clearCart() {
        fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok")
            }
            return response.json()
          })
          .then((data) => {
            store.getCart()
          })
          .catch((error) => {
            devLog(error)
          })
      },

      selling_planName(item) {
        if (item.selling_plan_allocation) {
          return item.selling_plan_allocation.selling_plan.name
        } else {
          return null
        }
      },
      scrollUpdate(e) {
        this.scrollY = window.scrollY
      },
      async gotoCheckout(discountCode) {
        try {
          let hcp_status = await this.checkHCPCode(discountCode)
          if (hcp_status && hcp_status == "ok") {
            // redirecting to stripe checkout
          } else {
            // redirecting to shopify checkout
            if (discountCode && discountCode != "") {
              this.applyDiscount()
            } else {
              window.location.href = "/checkout"
            }
          }
        } catch (e) {
          window.location.href = "/checkout"
        }
      },
      openCheckout() {
        let discountCode = this.provider_code
        if (
          !discountCode ||
          discountCode == "" ||
          discountCode == null ||
          discountCode == "null"
        ) {
          discountCode = this.discountCode
        }
        this.gotoCheckout(discountCode)
        this.checkoutLoading = true
        this.$refs.checkoutBtnText.innerHTML = "Processing ..."
        setTimeout(() => {
          //  this.checkoutLoading=false;
          this.$refs.checkoutBtnText.innerHTML = "Redirecting to Checkout ..."
        }, 1500)
        setTimeout(() => {
          //  $('body').addClass('opacity-0 transition duration-500');
        }, 1500)
        setTimeout(() => {
          this.checkoutLoading = false
        }, 8000)
      },
      async applyDiscount() {
        let discountCode = this.discountCode
        if (discountCode) {
          this.addingDiscount = true

          try {
            // Admin token stays server-side: lookup-code resolves it from the store record (isShopify policy).
            const response = await fetch(
              "https://prolon-pro.herokuapp.com/stores/lookup-code?shop=prolon-fmd-2020.myshopify.com&discount=" +
                encodeURIComponent(discountCode)
            )

            if (!response.ok) {
              throw new Error("Network response was not ok")
            }

            const data = await response.json()
            devLog(data)

            if (data && data.id) {
              location.href = "/checkout?discount=" + discountCode
            } else {
              this.ShowDiscountFailedMessage = true
              this.addingDiscount = false
              setTimeout(() => {
                this.ShowDiscountFailedMessage = false
              }, 3000)
            }
          } catch (error) {
            devLog(error)
            this.ShowDiscountFailedMessage = true
            this.addingDiscount = false
            setTimeout(() => {
              this.ShowDiscountFailedMessage = false
            }, 3000)
          }
        } else {
          this.ShowDiscountFailedMessage = true
          setTimeout(() => {
            this.ShowDiscountFailedMessage = false
          }, 3000)
          // alert("Please enter a discount code");
          this.addingDiscount = false
        }
      },

      async checkHCPCode() {
        let code
        let patientDiscountcode = this.discountCode
        if (
          !code ||
          code == "" ||
          code == null ||
          code == undefined ||
          code == "null"
        ) {
          code = this.provider_code
        }
        if (
          !code ||
          code == "" ||
          code == null ||
          code == "null" ||
          code == undefined ||
          code == "undefined"
        ) {
          code = this.discountCode
        }
        if (
          !code ||
          code == "" ||
          code == null ||
          code == "null" ||
          code == undefined ||
          code == "undefined"
        ) {
          return null
        }

        if (code && code != "" && this.hasValidStripeProducts) {
          try {
            let codeStatusData = await fetch(
              `${API_URL}stores/hcp-lookup?hcp_code=${code}`
            )
            let codeStatus = await codeStatusData.json()

            if (
              codeStatus &&
              codeStatus.status &&
              (codeStatus.stripe_connect ||
                codeStatus?.customer?.provider_type == "no_commission")
            ) {
              let cart = this.cart
              let discountcode = code
              let shop = Shopify.shop || "prolon-fmd-2020.myshopify.com"
              // if(patientDiscountcode && patientDiscountcode!='' && patientDiscountcode!=code){
              //   discountcode+=`,${patientDiscountcode}`
              // }
              let accountId = codeStatus?.stripe_connect?.account_id

              if (codeStatus?.customer?.provider_type == "no_commission") {
                accountId = "no_commission"
              }
              let data = {
                stripe_connect_account_id: accountId,
                hcp_code: discountcode,
                ...cart,
              }

              // let _url = `${API_URL}stores/stripe/create-checkout-session?shop=${shop}`;

              if (
                codeStatus &&
                (codeStatus.stripe_connected ||
                  codeStatus?.customer?.provider_type == "no_commission")
              ) {
                let url = `/pages/secure-checkout?secure_code=${btoa(
                  accountId
                )}`
                location.href = url
                return "ok"
              }

              let _url = `${API_URL}stores/stripe/create-checkout-session?shop=${shop}`
              let only_klarna = getParam("only_klarna")
              if (only_klarna == "1") {
                _url += "&only_allow_klarna=1"
              } else {
                _url += "&with_klarna=1"
              }

              let response
              try {
                const fetchResponse = await fetch(_url, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json; charset=utf-8",
                  },
                  body: JSON.stringify(data),
                })

                if (!fetchResponse.ok) {
                  throw new Error(`HTTP error! Status: ${fetchResponse.status}`)
                }

                response = await fetchResponse.json()
              } catch (error) {
                console.error("Fetch error:", error)
              }

              if (response) {
                if (response.url) {
                  fetch("/cart/clear").then((response) => {
                    devLog("cart cleared")
                  })

                  window.location = response.url
                  return "ok"
                } else {
                  devLog("stripe-connect-error", response)
                  this.checkoutLoading = false
                  return null
                }
              } else {
                this.checkoutLoading = false
                return null
              }
            } else {
              this.checkoutLoading = false
              return null
            }
          } catch (e) {
            return null
          }
        }
      },
      // An applied HCP / provider code is worth 5% on a one-time line and 20%
      // on a subscription line, +5% each while the "HCP extra 5% discount"
      // theme setting is on (never on the Prolon 5-Day kit — see hcpLineRate). Subscriptions ship two ways here: a real
      // Shopify selling plan, or the "Subscribe & Save" product option (most
      // ProLon products), so variant_title is often the only signal.
      // Every subscription ships free, so a cart whose paid lines are ALL
      // subscriptions clears the free-shipping milestone on its own — the bar
      // reads full instead of asking for more spend. A single one-time line
      // anywhere in the cart drops the bar back to the plain $ threshold.
      // Free lines (gifts) are filtered out; they would otherwise make an
      // all-subscription cart read as mixed.
      allLinesSubscription() {
        let items = (this.cartData?.[0]?.items || []).filter(
          (item) => item && item.original_line_price > 0
        )
        if (items.length === 0) return false
        return items.every((item) => this.hcpIsSubscriptionLine(item))
      },
      hcpIsSubscriptionLine(item) {
        if (!item) return false
        if (item.selling_plan_allocation && item.selling_plan_allocation.price) {
          return true
        }
        return /subscribe/i.test(
          (item.variant_title || "") + " " + (item.title || "")
        )
      },
      // The 20% subscription rate is only offered on the ProLon Professionals
      // page, which is the only place set up for it
      // (subscription_discount_percentage: 20 in the hcp-lp template). Any
      // product not sold there stays on the flat 5%, subscription or not.
      hcpIsProfessionalsLine(item) {
        if (!item) return false
        if (HCP_SUBSCRIPTION_PRODUCT_IDS.includes(Number(item.product_id))) {
          return true
        }
        return HCP_SUBSCRIPTION_HANDLES.includes(item.handle || "")
      },
      // The Prolon 5-Day Fasting Mimicking Program kit always stays on
      // 5% one-time / 20% subscription.
      hcpIsFiveDayLine(item) {
        if (!item) return false
        if (HCP_FIVE_DAY_PRODUCT_IDS.includes(Number(item.product_id))) {
          return true
        }
        return HCP_FIVE_DAY_HANDLES.includes(item.handle || "")
      },
      // Price multiplier for a line once the provider code is applied.
      hcpLineRate(item) {
        let off =
          this.hcpIsSubscriptionLine(item) && this.hcpIsProfessionalsLine(item)
            ? 20
            : 5
        if (window.HCP_EXTRA_DISCOUNT_ENABLED && !this.hcpIsFiveDayLine(item)) {
          off += 5
        }
        return (100 - off) / 100
      },
      // Rounded to whole cents so the line prices always add up to the subtotal
      // in hcpDiscountedTotal.
      hcpLinePrice(item) {
        if (!item) return 0
        if (item.is_loop_bundle) {
          return item.bundle_lines.reduce((sum, l) => sum + this.hcpLinePrice(l), 0)
        }
        return Math.round((item.original_line_price || 0) * this.hcpLineRate(item))
      },
      getLinePrice(item) {
        if (item.is_loop_bundle) {
          return item.bundle_lines.reduce((sum, l) => sum + this.getLinePrice(l), 0)
        }
        if (item.properties && item.properties._price) {
          return item.properties._price * item.quantity
        }
        return item.final_line_price
      },
    },
    computed: {
      // Lean-cart A/B arms. Variant 1 is the cart that ships today; 2 drops both
      // optional sections; 3 keeps expedited shipping only. Every other guard on
      // those sections (cart not empty, variant already in cart, all upsells in
      // cart) still applies on top of these.
      lcShowExpedited() {
        return this.leanVariant !== 2
      },
      lcShowRecommendations() {
        return this.leanVariant === 1
      },
      // The hardcoded row at the top of the recommendations card
      // (snippets/dk-new-year-bundle-lean.liquid) - which product it offers is
      // decided by changeUpsellType, and it hides once that product is in cart.
      lcHardcodedUpsellAvailable() {
        let item = null
        if (this.changeUpsellType === "longevity-nutrition-kit") {
          item = this.new_year_bundle
        } else if (this.changeUpsellType === "l-protein") {
          item = this.prolon_protein
        }
        return !!item && !this.isInCartByHandle(item)
      },
      // Whether the "Recommended for you" card still has any row to render:
      // the hardcoded row above, or a collection product not already in cart.
      // isAllUpsellinCart() alone hid the card - hardcoded row included - as
      // soon as every collection product was in the cart.
      lcHasRecommendations() {
        let items = store.state.recommendedCollection || []
        let hasCollectionRow = items.some(
          (product) =>
            product &&
            product.variants &&
            product.variants.length > 0 &&
            !this.isInCart(product)
        )
        return hasCollectionRow || this.lcHardcodedUpsellAvailable
      },
      changeUpsellType() {
        // Check window variable for upsell type, similar to free_prolon_gift pattern
        return "l-protein" //window.change_upsell || 'longevity-nutrition-kit';
      },
      shop_now_link() {
        if (this.provider_code) {
          return `/products/prolon-professionals?hcp=${this.provider_code}`
        }
        return `/collections/all`
      },
      maxAmount() {
        return Math.max(...this.milestones.map((m) => m.amount))
      },
      gifts() {
        return store.state.allowedGifts.filter(
          (gift) => gift.enabled && gift.isDisplay
        )
      },

      isGiftInCart() {
        // const remainingGifts = this.gifts.filter((gift) => gift.targetValue > this.orderValue);
        const lastAchievedGift =
          this.gifts?.find((gift) => gift.type == "choose_gift") || null
        let allowed_variants = store.allowedVariants(lastAchievedGift)
        if (allowed_variants && allowed_variants.length > 0) {
          let isGiftInCart = 0
          allowed_variants.forEach((variant) => {
            let variantInCart = this.cartData[0].items.find(
              (item) => item.variant_id == variant
            )
            if (variantInCart) {
              isGiftInCart += variantInCart.quantity
            }
          })
          return isGiftInCart >= 1 ? true : false
        }
      },
      freeGiftsAchieved() {
        // const remainingGifts = this.gifts?.filter((gift) => gift.targetValue > this.orderValue) || [];
        // if (remainingGifts.length === 0) {
        //   return true;
        // }
        let hasSubscriptionProduct = false
        let prolonSKUs = [
          "PR001",
          "PR002",
          "PR039",
          "PR001-RKBUNDLE",
          "PR002-RKBUNDLE",
          "PR039-RKBUNDLE",
          "PR039-3Boxbundle",
          "PR004",
          "PR039-PNK",
          "PR001-2BOX",
          "PR002-2BOX",
          "PR0039-2BOX",
          "PR001-3BOX",
          "PR002-3BOX",
          "PR0039-3BOX",
          "4boxbulk",
          "PR039-4Boxbundle",
          "3boxbulk",
          "HOLIDAY-BUNDLE",
          "longevity-bundle",
          "if-bundle",
        ]
        // check if cart has subscription product also if cart has prolon product
        this.cartData?.[0]?.items?.forEach((item) => {
          if (
            item?.selling_plan_allocation &&
            item?.selling_plan_allocation?.price &&
            prolonSKUs.includes(item.sku)
          ) {
            hasSubscriptionProduct = true
          }
        })

        if (hasSubscriptionProduct) {
          return true
        }
        return false

        // const lastAchievedGift = this.gifts[this.gifts?.length - 1];

        // const nextTargetValue = remainingGifts[0].targetValue;
        // let remainingValue = nextTargetValue - this.orderValue;
        // remainingValue = remainingValue.toFixed(2);

        return remainingValue <= 0
      },
      recommendedUpsells() {
        let cart = store.state.shopify_cart
        let upsells = []
        if (!cart) {
          return []
        }
        let cartItems = cart
        devLog(`shopify_cart`, cartItems)
        cartItems.forEach((item) => {
          if (item && item.upsell_products) {
            item.upsell_products.forEach((upsell) => {
              upsell.variants = upsell.variants.map((e) => {
                e.price = e.price / 100

                return e
              })

              let isAlreadyInUpsells = upsells.find((e) => e.id == upsell.id)

              if (!isAlreadyInUpsells) {
                upsells.push(upsell)
              }
            });
          }
        });

        devLog("upsells", upsells);
        return upsells;
      },
      loadingCart() {
        return store.state.loadingCart
      },

      // Label shown in the bracket next to an applied HCP / provider code — it
      // follows what is actually in the cart (see hcpIsSubscriptionLine). Free
      // lines (gifts) are ignored, they would otherwise make every subscription
      // cart read as mixed.
      hcpDiscountLabels() {
        let items = (this.cartData?.[0]?.items || []).filter(
          (item) => item && item.original_line_price > 0
        )
        // One label per distinct rate, so a cart mixing the 5-Day kit with
        // other products shows both rates.
        let labels = []
        ;[false, true].forEach((subscription) => {
          items
            .filter((item) => this.hcpIsSubscriptionLine(item) === subscription)
            .forEach((item) => {
              let type = subscription ? "Subscription" : "One Time"
              let off = Math.round((1 - this.hcpLineRate(item)) * 100)
              let label = `${type} ${off}% Off`
              if (!labels.includes(label)) labels.push(label)
            })
        })
        if (labels.length === 0) {
          labels.push(`One Time ${window.HCP_EXTRA_DISCOUNT_ENABLED ? 10 : 5}% Off`)
        }
        return labels
      },
      // Pill on the floating HCP code badge — one rate, or the best one when
      // the cart mixes rates.
      hcpBadgeText() {
        let rates = this.hcpDiscountLabels.map((label) => parseInt(label.match(/\d+/)[0]))
        let max = Math.max(...rates)
        return rates.every((rate) => rate === max) ? `${max}% OFF` : `UP TO ${max}% OFF`
      },

      // Subtotal with the provider code applied, discounted per line so a mixed
      // cart bills each line at its own rate. Replaces the old flat
      // `original_total_price * .95`.
      hcpDiscountedTotal() {
        let cart = this.cartData?.[0]
        if (!cart) return 0

        let items = cart.items || []
        if (items.length === 0) return cart.original_total_price || 0

        return items.reduce((sum, item) => sum + this.hcpLinePrice(item), 0)
      },
      cartTotal() {
        if (this.cartData.length > 0) {
          return this.cartData[0].total_price
        }
      },
      original_total_price() {
        if (this.cartData.length > 0) {
          return this.cartData[0].original_total_price
        }
      },
      cartCount() {
        if (this.cartData.length > 0) {
          return this.cartData[0].item_count
        }
      },
      // Same rule the milestone bar runs on (see allLinesSubscription): every
      // subscription already ships free, so a cart whose paid lines are ALL
      // subscriptions is past the finish line at any subtotal. A single
      // one-time line drops this back to the plain $ threshold.
      isFreeShipping() {
        if (this.cartData.length > 0) {
          if (this.allLinesSubscription()) {
            return true
          }
          return (
            this.cartData[0].total_price >=
            freeShippingSettings.freeShippingThreshold
          )
        }
      },
      remaingShippingPercetange() {
        if (this.cartData.length > 0) {
          if (this.allLinesSubscription()) {
            return 100
          }
          let percentage =
            (this.cartData[0].total_price /
              freeShippingSettings.freeShippingThreshold) *
            100
          if (percentage > 100) {
            percentage = 100
          }
          return percentage
        }
      },

      awayFromFreeShipping() {
        if (this.cartData.length > 0) {
          if (this.allLinesSubscription()) {
            return 0
          }
          return (
            freeShippingSettings.freeShippingThreshold -
            this.cartData[0].total_price
          )
        }
      },
      freeShippingMessage() {
        let cart_total = this.cartData?.[0]?.total_price / 100
        if (cart_total && cart_total >= 199) {
          return "".toUpperCase()
        }

        if (this.cartData.length > 0) {
          // Nothing left to ask for once every line is a subscription.
          if (this.allLinesSubscription()) {
            return ""
          }
          return freeShippingSettings.freeShippingMessage.replace(
            "_value_",
            this.money(freeShippingSettings.freeShippingThreshold)
          )
        }
      },
      showTopLine() {
        return this.cartTotal / 100 < 250
        return true
      },
      gotFreeShippingMessage() {
        let cart_total = this.cartData?.[0]?.total_price / 100
        // if(cart_total && cart_total >= 250){
        // return `🎉 You’ve earned free shipping!`
        // }
        if (this.cartData.length > 0) {
          if (this.allLinesSubscription()) {
            return freeShippingSettings.successMessage
          }
          if (
            this.cartData[0].total_price >=
            freeShippingSettings.freeShippingThreshold
          ) {
            return freeShippingSettings.successMessage
          } else {
            return ""
          }
        }
      },
      awayFreeShippingMessage() {
        let cart_total = this.cartData?.[0]?.total_price / 100
        // let thrithyPercetnageOffAway = 250 - cart_total;
        // if(cart_total && cart_total >= 200 && cart_total<250){
        //   return freeShippingSettings.remainingMessage.replace(
        //     "_value_",
        //     this.money(thrithyPercetnageOffAway*100)
        //   );

        // }

        if (this.cartData.length > 0) {
          if (this.allLinesSubscription()) {
            return ""
          }
          if (
            this.cartData[0].total_price <
            freeShippingSettings.freeShippingThreshold
          ) {
            return freeShippingSettings.remainingMessage.replace(
              "_value_",
              this.money(this.awayFromFreeShipping)
            )
          } else {
            return ""
          }
        }
      },

      isvisibleCart() {
        return !slideCartState.hidden
      },
      menuDrawer() {
        return menuState.hidden
      },
      cart() {
        return this.cartData[0]
      },
      // Cart lines as the drawer shows them: Loop bundle children folded into
      // one row each (groupLoopBundleLines), in cart order.
      displayCartItems() {
        return groupLoopBundleLines(this.cartData[0]?.items)
      },
      reverseCart() {
        let items = this.displayCartItems
        if (items && items.length > 0) {
          items = items.filter((e) => {
            return e.sku != "TIER6"
          })
        }

        return items?.reverse()
      },
      recommendedCollectionNew() {
        if (this.recommendedUpsells && this.recommendedUpsells.length > 0) {
          return this.recommendedUpsells
        } else {
          return store.state.recommendedCollection
        }
      },
      freeGiftsCollection() {
        return store.state.freeGiftsCollection
      },
      recommendedCollection() {
        return store.state.recommendedCollection
      },

      disableCart() {
        return store.state.updatingCart
      },
    },
    mounted() {
      let scrollEvent = this.scrollUpdate
      document.addEventListener("scroll", function (e) {
        scrollEvent(e)
      })

      // Cart page (sections/main-cart.liquid renders the bar with pgpb_page: true):
      // the bar is on the page from the start, so there is no drawer-open event
      // to hang the variant-B reveal on. Wait a beat for the bucketer to assign,
      // then pop the bubbles once.
      if (document.querySelector('[data-pgpb-page="true"]')) {
        setTimeout(() => {
          this.promoGiftBubbles = promoGiftBubblesOn()
          if (this.promoGiftBubbles) {
            this.$nextTick(() => this.promoGiftRevealAllBubbles())
          }
        }, 600)
      }

      // Reset the checkout button when the user returns to the cart (e.g. back from Shopify checkout).
      // Covers bfcache restore (`pageshow` persisted=true), fresh reload, and tab-return (visibilitychange).
      const resetCheckoutButton = () => {
        this.checkoutLoading = false
        this.$nextTick(() => {
          const btnEl =
            (this.$refs && this.$refs.checkoutBtnText) ||
            document.querySelector(".checkout-btn-wrapper button span:last-of-type")
          if (btnEl) btnEl.innerHTML = "CHECKOUT"
        })
      }
      // Console switch for the gift-image test — QA only, sessionStorage so it
      // cannot outlive the tab. An A/B assignment (window.PROMO_GIFT_BUBBLES)
      // always wins over it. See snippets/king-promo-gift-config.liquid.
      window.PromoGiftBubbles = {
        on: () => {
          try {
            sessionStorage.setItem("promo_gift_bubbles_qa", "1")
          } catch (e) {}
          this.promoGiftBubbles = promoGiftBubblesOn()
          this.$nextTick(() => this.promoGiftRevealAllBubbles())
          return "gift bubbles ON (this tab only)"
        },
        off: () => {
          try {
            sessionStorage.removeItem("promo_gift_bubbles_qa")
          } catch (e) {}
          this.promoGiftHideAllBubbles()
          this.promoGiftBubbles = promoGiftBubblesOn()
          return "gift bubbles OFF (this tab only)"
        },
      }

      // Console switch for the lean cart redesign — see snippets/king-slide-cart-lean.liquid
      // The lean cart is the default, so off() is the override that has to be
      // stored; reset() drops the override and goes back to that default.
      const vm = this
      window.LeanCart = {
        // QA override, sessionStorage so it cannot outlive the tab. An A/B
        // assignment (window.LEAN_CART) always wins over this.
        on() {
          if (window.__leanCartFonts) window.__leanCartFonts()
          try {
            sessionStorage.setItem("lean_cart_qa", "1")
          } catch (e) {}
          vm.leanCart = true
          toggleCart.showCart()
          return "lean cart ON (this tab only)"
        },
        off() {
          try {
            sessionStorage.setItem("lean_cart_qa", "0")
          } catch (e) {}
          vm.leanCart = !!(window.__leanCartOn && window.__leanCartOn())
          toggleCart.showCart()
          return vm.leanCart
            ? "QA override set, but an A/B assignment is still forcing the lean cart"
            : "lean cart OFF (original slide cart, this tab only)"
        },
        // Clear the QA override and fall back to whatever ships — the lean cart,
        // unless an A/B assignment says otherwise.
        reset() {
          try {
            sessionStorage.removeItem("lean_cart_qa")
          } catch (e) {}
          vm.leanCart = !!(window.__leanCartOn && window.__leanCartOn())
          if (vm.leanCart && window.__leanCartFonts) window.__leanCartFonts()
          return vm.leanCart
            ? "QA override cleared, back on the lean cart (default)"
            : "QA override cleared, an A/B assignment is holding the original cart"
        },
        toggle() {
          return vm.leanCart ? window.LeanCart.off() : window.LeanCart.on()
        },
        open() {
          toggleCart.showCart()
          return vm.leanCart ? "opened (lean)" : "opened (original)"
        },
        close() {
          vm.closeAllDrawers()
          return "closed"
        },
        get isOn() {
          return vm.leanCart
        },
        // QA switch for the section test inside the lean cart:
        //   LeanCart.variant(1) -> expedited + recommendations (ships today)
        //   LeanCart.variant(2) -> neither
        //   LeanCart.variant(3) -> expedited only
        //   LeanCart.variant()  -> read the current arm
        // sessionStorage again, so it dies with the tab, and an A/B assignment
        // (window.LEAN_CART_VARIANT) always wins over it.
        variant(n) {
          if (n === undefined) return vm.leanVariant
          const v = parseInt(n, 10)
          if (v !== 1 && v !== 2 && v !== 3) return "variant must be 1, 2 or 3"
          try {
            sessionStorage.setItem("lean_cart_variant_qa", String(v))
          } catch (e) {}
          vm.leanVariant =
            (window.__leanCartVariant && window.__leanCartVariant()) || 1
          toggleCart.showCart()
          return vm.leanVariant === v
            ? `lean cart variant ${v} (this tab only)`
            : `QA override set, but an A/B assignment is holding variant ${vm.leanVariant}`
        },
        // Drop the variant QA override, back to the assigned/default arm.
        resetVariant() {
          try {
            sessionStorage.removeItem("lean_cart_variant_qa")
          } catch (e) {}
          vm.leanVariant =
            (window.__leanCartVariant && window.__leanCartVariant()) || 1
          return `variant override cleared, now on variant ${vm.leanVariant}`
        },
      }

      window.addEventListener("pageshow", resetCheckoutButton)
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") resetCheckoutButton()
      })
      resetCheckoutButton()
    },
    components: {
      "single-upsell": SingleUpsell,
      "single-upsell-new": SingleUpsellNew,
      "upsell-slider": UpsellSlider,
      "lean-upsell": LeanUpsellCard,
      carousel: VueCarousel.Carousel,
      slide: VueCarousel.Slide,
      pagination: VueCarousel.Pagination,
      navigation: VueCarousel.Navigation,
    },
    created() {
      store.getCart()
      store.getRecommendedCollection()
      store.getFreeGiftsCollection()
      let view = getParam("view")
      if (view && view == "redirect_to_stripe_checkout") {
        // let discountCode = getParam("hcp_code");
        let provider_code = getParam("hcp_code")
        this.provider_code = provider_code
        this.gotoCheckout()
      }

      // Initialize emitter if it doesn't exist
      if (!window.emitter) {
        window.emitter = {
          events: {},
          on(event, callback) {
            if (!this.events[event]) {
              this.events[event] = []
            }
            this.events[event].push(callback)
          },
          emit(event, data) {
            if (this.events[event]) {
              this.events[event].forEach((callback) => callback(data))
            }
          },
        }
      }

      // Close the drawer on Escape, as assets/header-drawer.js does for the menu.
      document.addEventListener("keyup", (event) => {
        if (event.key !== "Escape" || slideCartState.hidden) return
        this.closeAllDrawers()
      })

      window.emitter.on("new_provider_code", (e) => {
        if (e.code && e.code != "" && e.code != this.provider_code) {
          this.provider_code = e.code
          // An HCP code locks the promo goal back to the default.
          this.promoGiftRefresh()
        }
      })

      // The A/B tool moved this visitor's promo goal (PromoGift.setGoal()).
      document.addEventListener("promo-gift:goal", () => this.promoGiftRefresh())
    },
    watch: {
      isvisibleCart: function (val) {
        // Dialog focus handling (WCAG 2.1.2 / 2.4.3), as assets/header-drawer.js does for
        // the menu: trap focus inside the drawer while open, release it on close, then
        // hand focus back to whatever opened it.
        if (val) {
          slideCartOpener = document.activeElement
          document.addEventListener("keydown", slideCartTrap.keydown, true)
          document.addEventListener("focusin", slideCartTrap.focusin, true)
          this.$nextTick(() => {
            const root = slideCartRoot()
            if (root) root.focus()
          })
        } else {
          document.removeEventListener("keydown", slideCartTrap.keydown, true)
          document.removeEventListener("focusin", slideCartTrap.focusin, true)
          if (slideCartOpener && slideCartOpener.isConnected) slideCartOpener.focus()
          slideCartOpener = null
        }
        // Re-resolve the lean-cart assignment every time the drawer opens. data()
        // runs when the deferred CK bundle boots, which can be before an external
        // bucketer (Intelligems) has set window.LEAN_CART — but never before the
        // shopper actually opens the cart, so resolving here removes that race.
        if (val) {
          const assigned = !!(window.__leanCartOn && window.__leanCartOn())
          if (assigned !== this.leanCart) {
            if (assigned && window.__leanCartFonts) window.__leanCartFonts()
            this.leanCart = assigned
          }

          // Same race, same fix for the variant arm (1/2/3).
          const variant =
            (window.__leanCartVariant && window.__leanCartVariant()) || 1
          if (variant !== this.leanVariant) this.leanVariant = variant
        }

        // Same race for the gift-image test, and the same fix: re-resolve the
        // assignment as the drawer opens, then pop the bubbles. Closing the
        // drawer clears them so the next open always starts from nothing.
        if (val) {
          this.promoGiftBubbles = promoGiftBubblesOn()
          if (this.promoGiftBubbles) {
            this.$nextTick(() => this.promoGiftRevealAllBubbles())
          }
        } else {
          this.promoGiftHideAllBubbles()
        }

        let providerCode = localStorage.getItem("provider_code")
        if (!this.provider_code) {
          if (providerCode && providerCode != "null") {
            this.provider_code = providerCode
          }
        }

        if (!providerCode) {
          let discountCode = localStorage.getItem("discount_code")
          if (discountCode && discountCode != "null") {
            this.discountCode = discountCode
          }
        }
      },
      original_total_price: function (val) {
        // original_total_price
        //offer-bar
        if (val) {
          try {
            document
              .querySelector("offer-bar")
              .setAttribute("subtotal", val / 100)
          } catch (ex) {}
        }
      },
    },
  }).mount("#cart-with-header")
}

$(document).on("ajaxProduct:added", function () {
  toggleCart.showCart()
})

$(document).on("click", ".js-drawer-open-cart", function (e) {
  if (window.CART_TYPE == "DRAWER") {
    e.preventDefault()
    toggleCart.showCart()
  }
})
